/**
 * External dependencies.
 */
import '../node_modules/foundation-sites/dist/js/foundation';
//import '../node_modules/slick-carousel';
//import '../node_modules/magnific-popup';
import '../node_modules/selectric';
import '../node_modules/jquery-mousewheel';
import '../node_modules/malihu-custom-scrollbar-plugin';
import Plyr from '../node_modules/plyr';
import tippy from '../node_modules/tippy.js';
//import Valy from '../node_modules/valy'; // Non utilisé

/**
 * Declare common variables.
 */
var $win = $(window);
var $doc = $(document);

var $header = $('.header');
var $footer = $('.footer');
var $wrapper = $('.wrapper');
var $navContainer = $('.nav');
var $linksPopoverItems = $('.list-links--popover > li');
var $menuContainer = $('.nav-box');
var $menuLinkAgency = $('.block-agency__link');
var $menuLinkPhone = $('.block-agency__number');
var $menuPopover = $('.block-agency__popover');
var $menuLinkAccount = $('.block-account__link');
var $menuPopoverAccount = $('.block-account__popover');
var $sectionOffers = $('.section--offers');
var $navDropdownItems = $navContainer.find('> ul > li.has-children');

var $loadMore = $('.js-load-more');
var $mobileNav = $('.js-nav-holder');
var $stickyItem = $('.js-sticky-item');
var $sliderMobile = $('.js-slider-mobile');
var $customSelect = $('.js-custom-select');
//var $toggleElement = $('.js-toggle-items');
var $customPlayer = $('.js-custom-player');
var $formValidation = $('.js-init-validation');
var $btnGeolocation = $('.js-get-geolocation');
var $customScrollbar = $('.js-custom-scrollbar');
var $locationAutocomplete = $('.js-location-autocomplete');
var $emptyCross = $('.form__empty-cross');

var cachedScrollPos;
var currentScrollPos;
var winHeight;

var isMobileLayout = false;
var isTabletLayout = false;
var isDesktopLayout = false;

var lastScrollTop = null;
var dataFormApply = {};
window.stepHistory = [0];

window.toggleStory = [""];

window.setItemLocalStorage = function (name, value) {
    try {
        window.localStorage.setItem(name, value);
    } catch (e) {
    }
};

window.setItemSessionStorage = function (name, value) {
    try {
        window.sessionStorage.setItem(name, value);
    } catch (e) {
    }
};
window.getItemLocalStorage = function (name) {
    try {
        return window.localStorage.getItem(name);
    } catch (e) {
        return null;
    }
};

window.getItemSessionStorage = function (name) {
    try {
        return window.sessionStorage.getItem(name);
    } catch (e) {
        return null;
    }
};
window.removeItemLocalStorage = function (name) {
    try {
        window.localStorage.removeItem(name);
    } catch (e) {
    }
};

window.removeItemSessionStorage = function (name) {
    try {
        window.sessionStorage.removeItem(name);
    } catch (e) {
    }
};

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');

    for (var i = 0; i < ca.length; i++) {

      var c = ca[i];

      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

window.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

window.deleteCookie = function (cname) {
    document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

window.checkCookie = function (cname) {
    var name = getCookie(cname);

    if (name != "") {
        return name;
    } else {
        return 'undefined';
    }
}


/**
 * Clean address field
 */
function cleanAddressField() {
    displayCross();

    $locationAutocomplete.change(function () {
        displayCross();
    })
    $emptyCross.click(function () {
        $locationAutocomplete.val('');
        displayCross();
    })
}

/**
 * Display cross in input
 */
function displayCross() {
    if ($locationAutocomplete.val() === '') {
        $emptyCross.css('display', 'none');
    } else {
        $emptyCross.css('display', 'block');
    }
}

/**
 * Fetch data form json file.
 * @param  {string} src
 */
function fetchData(src) {
    return $.ajax({
        url: src,
        type: 'GET',
        dataType: 'json'
    });
}

/**
 * Template structuring
 */
function template(str, vars) {
    return str.replace(/{{([^}]+)}}/g, function (match, property) {
        var arr = property.split('.');
        var obj = vars[arr.shift()];

        while (arr.length > 0 && typeof obj === 'object') {
            obj = obj[arr.shift()];
        }

        return typeof obj === 'undefined' ? match : obj;
    });
}

/**
 * Close element on click on the document.
 * @param  {object} $target  JQuery Object
 * @param  {object} $element JQuery Object
 * @param  {string} parent
 * @param  {function} closeFn
 */
function closeElementFromTarget($target, $element, parent, closeFn) {
    if (!$target.is($element) && !$target.parents(parent).length) {
        closeFn();
    }
}

/**
 * Check layout type.
 */
function checkLayoutType() {
    if ($win.outerWidth() >= 320 && $win.outerWidth() <= 767) {
        if (isMobileLayout) {
            return;
        }

        isMobileLayout = true;
        isTabletLayout = false;
        isDesktopLayout = false;

        /**
         * Initialize of handleMobileNav functionality.
         */
        handleMobileNav($mobileNav);

        /**
         * Setting height as high as window is to mobile navigation.
         */
        $menuContainer.css('height', winHeight);

        /**
         * Initialize of handleCustomModal functionality.
         */
        //handleCustomModal();

        /**
         * Initialize of mobile slider.
         */
        $sliderMobile.slick({
            infinite: true,
            mobileFirst: true,
            dots: true,
            arrows: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
        });
    } else if ($win.outerWidth() > 767 && $win.outerWidth() < 1025) {
        if (isTabletLayout) {
            return;
        }

        isMobileLayout = false;
        isTabletLayout = true;
        isDesktopLayout = false;

        /**
         * Destroy of mobile slider.
         */
        if ($('.js-slider-mobile.slick-initialized').length) {
            $sliderMobile.slick('unslick');
        }

        $('.parent-link').on('click', function (event) {
            event.preventDefault();
            var $parent = $(this).closest('li');
            if (!$parent.hasClass('active')) {
                if ($parent.find('.nav__dropdown-body').height() === 0) {
                    $parent.removeClass('active').siblings().removeClass('active');
                    $wrapper.removeClass('hovered');
                    var link = $(this).attr('href');
                    window.location = link;

                } else {
                    event.preventDefault();
                    $parent.toggleClass('active').siblings().removeClass('active');
                    $wrapper.addClass('hovered');
                }
            } else {
                $parent.removeClass('active');
                $wrapper.removeClass('hovered');
            }
        });

        $navContainer.find('> ul > li:not(.has-children) a').on('click', function () {
            $(this).closest('.nav').find('.active').removeClass('active');
            $wrapper.removeClass('hovered');


        })

        /**
         * Initialize of popover tablet functionality.
         */
        $linksPopoverItems.find('a').on('click', function (event) {
            event.preventDefault();
            var $linkParent = $(this).closest('li');

            if (!$linkParent.hasClass('active')) {
                event.preventDefault();

                $linkParent.toggleClass('active').siblings().removeClass('active');
            } else {
                $linkParent.removeClass('active');
            }
        });

        /**
         * Initialize of closeElementFromTarget functionality.
         */
        $doc.on('click', function (event) {
            closeElementFromTarget($(event.target), $navDropdownItems, 'nav', closeNavDropdown);
        });

        $doc.on('click', function (event) {
            closeElementFromTarget($(event.target), $linksPopoverItems, 'list-links--popover', closePopover);
        });

        /**
         * Remove style attributes.
         */
        $menuContainer.removeAttr('style');
        $menuContainer.find('.js-nav').removeAttr('style');
        $('.tab .tab__content').removeAttr('style');
    } else {
        if (isDesktopLayout) {
            return;
        }

        isMobileLayout = false;
        isTabletLayout = false;
        isDesktopLayout = true;

        if ($('.js-slider-mobile.slick-initialized').length) {
            $sliderMobile.slick('unslick');
        }

        /**
         * Initialize of navigation desktop functionality.
         */
        $navDropdownItems.on('mouseenter', function () {
            $wrapper.addClass('hovered');
        });

        $navDropdownItems.on('mouseleave', function () {
            $wrapper.removeClass('hovered');
        });

        /**
         * Remove style attributes.
         */
        $menuContainer.removeAttr('style');
        $menuContainer.find('.js-nav').removeAttr('style');
    }
}

/**
 * Close dropdown.
 */
function closeNavDropdown(target, ndi, type, fct) {
    $navDropdownItems.removeClass('active');
    $wrapper.removeClass('hovered');
}

function closePopover() {
    $linksPopoverItems.removeClass('active');
}

function showMenuPopover() {
    $menuLinkAgency.on('mouseenter', function () {
        $menuPopover.addClass('active');
    });

    $menuLinkAgency.on('mouseleave', function () {
        $menuPopover.removeClass('active');
    });

    $menuLinkAccount.on('mouseenter', function () {
      $menuPopoverAccount.addClass('active');
    });
    $menuLinkAccount.on('click', function (e) {
      e.preventDefault();
      $menuPopoverAccount.addClass('active');
    });
    $menuLinkAccount.on('mouseleave', function () {
        $menuPopoverAccount.removeClass('active');
    });

}


/**
 * Mobile navigation functionality
 * @param  {object} $navHolder JQuery Object
 */
function handleMobileNav($navHolder) {
    var $nav = $navHolder.find('.nav');
    var $navItemSlide = $navHolder.find('.js-nav-item-slide');
    var $navChildItem = $navItemSlide.find('.has-children-entry');
    var $navActiveContainer = $navHolder.addClass('nav-level');
    var $level1 = $('.js-nav-item-slide').find('.has-children-entry:nth-of-type(2)');
    var $level2 = $level1.find('li.has-children').slice(0, 2);
    var initialHeight = $('.js-nav').outerHeight();
    var isAnimating = false;
    var navLevel = 0;    

    //Moves 1 Level down
    $nav.find('.has-children > a, .has-children .nav__dropdown-subtitle ').on('click', function (event) {

        $('.nav-box__backdrop .js-menu-trigger').removeClass('leveled');

        if (!$(this).hasClass('parent-link-only')) {
            event.preventDefault();



            if (!isAnimating) {
                var $this = $(this);

                $navActiveContainer.removeClass('leveled');
                $this.closest('nav').addClass('ouvert');
                $('nav.nav:not(".ouvert")').hide();

                $navActiveContainer = $this.parent().addClass('nav-level leveled');

                navLevel++;

                positionNav(navLevel);

                resetAnimationFlag();

                setTimeout(function () {
                    $navHolder.animate({
                        scrollTop: 0
                    }, 100);
                }, 500);

                displayFoot();
            }
        }

    });

    //Moves 1 Level up
    $navHolder.find('.link-back').on('click', function (event) {

        event.preventDefault();

        $(this).closest('nav').removeClass('ouvert');
        $('nav.nav').show();

        if (!isAnimating) {
            $navActiveContainer = $navActiveContainer
                .removeClass('nav-level leveled')
                .closest('.nav-level')
                .addClass('leveled');

            navLevel--;

            positionNav(navLevel);

            resetAnimationFlag();

            setTimeout(function () {
                $navHolder.animate({
                    scrollTop: 0
                }, 100);
            }, 500);

            displayFoot();
        }
    });

    // Check si il y a déjà un handler click sur l'élément (Fix bug Zoom 75% --> 100%)

    var eventClick = $._data(jQuery("a.btn-menu.js-menu-trigger")[0], "events");

    if (eventClick==null) {
        $('.js-menu-trigger').on('click', function (event) {
            event.preventDefault();

            $level2.each(function () {
                $(this).find('.flex-no-grow').removeClass('hide-block-remember');
            });

            $('.nav-box').toggleClass('visible');
            //lockScroll($('.nav-box'));

            navLevel = 0;

            positionNav(navLevel);

            resetAnimationFlag();

            checkChildrenLength();

        });

    }
    
    function resetAnimationFlag() {
        isAnimating = true;

        setTimeout(function () {
            isAnimating = false;
        }, 300);
    }

    function positionNav(level) {
        var $currentDropdown = $navActiveContainer.children('.nav__dropdown');
        //Moves the navigation horizontally based on the deepness level

        $navItemSlide.each(function () {
            $(this).css('transform', 'translateX(-' + 100 * level + '%)');
        });

        if ($currentDropdown.length) {
            $('.js-nav').height($currentDropdown.innerHeight());
        } else {
            $('.js-nav').height(initialHeight);
        }
    }

    function displayFoot() {
        if ($('.nav-box__outer.nav-level.js-nav-holder').hasClass('leveled')) {
            $('.nav-box__foot').fadeIn();
        } else {
            $('.nav-box__foot').fadeOut();
        }
    }

    function checkChildrenLength() {
        $navChildItem.each(function () {
            var $childrenList = $(this).find('.nav__dropdown:not(.nav__dropdown__account) > .nav__dropdown-body > ul');
            console.log($childrenList);
            if ($childrenList.length == 1) {
                $(this).find('.nav__dropdown').remove();
                $(this).find('svg').remove();
                $(this).find('.parent-link').addClass('parent-link-only');
            }
        })
    }
}

/**
 * Toggle scroll lock.
 * @param {object} $element JQuery Object
 */
// function lockScroll($element) {
//     if ($element.hasClass('visible')) {
//         cachedScrollPos = currentScrollPos;
//         var scrollTop = -Math.abs(currentScrollPos);

//         $('body').toggleClass('noscroll').css({top: scrollTop});
//         $('.header').css({top: -scrollTop})
//     } else {
//         $('body').removeClass('noscroll').css({top: 0}).css({top: 0});

//         $('.header').css({top: 0})
//         $('.main').removeClass('visible');

//         $('html, body').scrollTop(cachedScrollPos);
//         lastScrollTop = cachedScrollPos;
//     }
// }

/**
 * Display select for classe
 */
function displayClass() {
    $('#field-address').on('selectric-change', function () {
        if ($('.field-class').val() !== '') {
            var selectClass = $('.field-class').data('selectric')
            selectClass.refresh()
            $('.form__controls-class').removeClass('animate-label')
            $('.field-class').on('selectric-change', function () {
                $('.form__controls-class').addClass('animate-label');
                $('.js-button-toggle').removeClass('disabled');
            });
        }
    });
}

/**
 * Init custom select.
 * @param  {object} $selectContainer JQuery Object
 */
window.initCustomSelect = function ($selectContainer) {
    var placeholder = $selectContainer.find('[data-placeholder]').text();
    var $btnClear = $selectContainer.parent().find('.js-clear-value');
    $selectContainer.selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
        onInit: function () {

            var $select = $(this);
            var $optionPlaceholder = $select.find('[data-placeholder]');
            var $optionSelected = $select.find('[selected]');
            var $selectWrapper = $select.closest('.selectric-wrapper');

            $select.closest('.select').addClass('select-initialized');

            if ($optionPlaceholder.length) {
                var placeholder = $optionPlaceholder.text();
                var $selectItems = $selectWrapper.find('li');

                if (!$optionSelected.length) {
                    $selectWrapper.find('.label').text(placeholder);
                }

                if ($('.agency-2').length) {
                    var label = $('.agency-2').next('.selectric label')
                    //console.log(label.text())

                    $('#agency-2 option').each(function (index) {
                        //console.log($(this).val() + ' - ' + window.getItemLocalStorage('agency_id'))
                        if (window.getItemLocalStorage('agency_id') == $(this).val()) {
                            $(this).addClass('selected')
                            //jQuery('.agency-2').parent().next('.selectric').children('span').text($(this).text())
                            jQuery(".agency-2").parent().parent().parent().parent().parent().addClass('animate-label')
                        }
                    });

                    //var city_selected = false;
                    // $('#agency-2.bloc-actu-list option').each(function (index) {

                    //     if(city_selected == false){
                    //         if (window.getItemLocalStorage('agency_id') == $(this).val()) {
                    //             $(this).addClass('selected')
                    //             jQuery('.actuhomelist .agency-2').parent().next('.selectric').children('span').text($(this).text())
                    //             jQuery(".actuhomelist .agency-2").parent().parent().parent().parent().parent().addClass('animate-label')
                    //             city_selected = true
                    //         }else{
                    //             if(!jQuery('.actuhomelist .agency-2').parent().next('.selectric').children('span').text().trim().length){
                    //                 jQuery("[for=agency-2]").hide()
                    //                 $(this).closest('.select').removeClass('select-initialized');
                    //                 jQuery('.actuhomelist .agency-2 .field-class').val('')
                    //                 jQuery('.actuhomelist2 .field-class').removeClass('select-initialized')
                    //                 jQuery('.actuhomelist2 .form__controls').addClass('form-item__disabled')
                    //                 jQuery('.actuhomelist2 .form__controls .selectric .label').text('')
                    //                 //var selectClass = jQuery('.actuhomelist2 #field-class')
                    //                 //selectClass.refresh()
                    //                 setTimeout(function(){
                    //                     jQuery('.actuhomelist .agency-2').parent().next('.selectric').children('span').text('Ville')
                    //                     jQuery('.actuhomelist2 .form__controls').addClass('form-item__disabled')
                    //                     if(!jQuery('.actuhomelist2 .field-class').parent().next('.selectric').children('span').text().trim().length){
                    //                         //jQuery('.actuhomelist2 .field-class').parent().next('.selectric').children('span').text('Classe')
                    //                     }
                    //                 }, 1000);

                    //             }


                    //             //
                    //         }
                    //     }

                    // });
                }

                for (let i = 0; i < $selectItems.length; i++) {
                    var $currentSelectItem = $($selectItems[i]);

                    if ($currentSelectItem.text() === placeholder) {
                        $currentSelectItem.addClass('placeholder');
                        $currentSelectItem.css('display', 'none');

                        if (!$optionSelected.length) {
                            $currentSelectItem.addClass('selected');
                        }

                    }
                }
            }

            initAnimationFormMobile();
        },
        onDestroy: function () {
            $(this).closest('.select').removeClass('select-initialized');
        },
        onChange: function () {
            $(this).closest('.select').addClass('has-value');
        },
    });

    var selectric = $selectContainer.data('selectric');

    $btnClear.on('click', function (event) {
        event.preventDefault();

        $(this).closest('.select').removeClass('has-value');

        selectric.destroy();

        setTimeout(function () {
            $selectContainer.val(placeholder);

            selectric.init();
        }, 10);
    });
}

/**
 * Get data using ajax request.
 * @param  {string} src
 * @param  {object} $item   JQuery Object
 * @param  {object} $target JQuery Object
 * @param  {object} $payLoad JQuery Object
 * @return {[type]}         [description]
 */
function getData(src, $item, $target, $payLoad) {
    var headerOffset;

    if ($item.hasClass('data-loaded') && !$(document).find('#form-config').length) {
        return false;
    } else {
        if ($(document).find('#form-config').length) {
            addLoader($target);
        }
        $.ajax({
            type: 'GET',
            url: src,
            dataType: 'html',
            data: $payLoad,
            beforeSend: function () {
                $('.loader').show();
            }
        }).done(function (response) {
            var $data = $(response);
            $item.addClass('data-loading');
            $('.loader').hide();
            $($target).removeClass('nopointer');
            $item.removeClass('data-loading').addClass('data-loaded');


            if ($(document).find('#form-config').length) {
                $target.html($data);
            } else {
                if ($(document).find('#nbProfs').length) {
                    $('#nbProfs').remove();
                    $($target).parent().removeClass('hide');
                }
                $data.appendTo($target);
            }

            if ($data.find('.accordion-expander').length) {
                Completude.InitHtmlComponent();
                initMapExpander();
            }
            if ($(document).find('[data-save-search]').length) {
                window.setItemSessionStorage('config-search', $payLoad);
            }
            if ($(document).find('[data-agency]').length) {
                var agency = JSON.parse($('[data-agency]').attr('data-agency'));
                window.setItemLocalStorage('agency_id', agency.id);
                disko.overrideAgencyNavBlock();
            }

            if ($data.find('[data-mapping]').length) {
                handleDataMapping();
            }

            if ($data.find('[data-move-to]').length) {
                handleSteps();
            }

            if ($(document).find('#nbProfs').length) {
                $($target).parent().removeClass('hide');
            }

            if ($(document).find('.course-config').length) {
                //$('.course-config').attr('data-min-courses', dataFormApply.minCourse);
                //$('.course-config').attr('data-max-courses', dataFormApply.maxCourse);
                $('#btn-submit-01').addClass('disabled');
            }

            if ($item.closest('form') && ($data.find('input') || $data.find('select'))) {
                handleFormValidation($item.closest('form'));
                handlePromoCode();
            }

            if ($(document).find('.google-map').length) {
                $(document).find('.google-map').each(function () {
                    window.initMap($(this), null, null, null);
                });
            }

            if ($item.find('[data-autoscroll]').length) {
                if (isMobileLayout) {
                    headerOffset = 0;
                } else {
                    headerOffset = $header.outerHeight();
                }

                $('body, html').animate({
                    scrollTop: $data.offset().top - headerOffset
                }, 600);
            }

        });
    }
}

/**
 * Enable form field.
 * @param  {object} $field JQuery Object
 */
function enableField($field) {
    $field.removeClass('form-item__disabled');
}

/**
 * Disabled form field.
 * @param  {object} $field JQuery Object
 */
function disableField($field) {
    $field.addClass('form-item__disabled');
}


/**
 * Update step section height.
 */
function updateSectionStepHeight() {
    var $sectionSteps = $('.section-form-steps');
    var mainHeight = $win.height() - $header.outerHeight() - $footer.outerHeight();

    if ($sectionSteps.find('.section__inner').outerHeight() < $sectionSteps.height()) {
        $sectionSteps.find('.section__inner').css('min-height', $sectionSteps.outerHeight());
    } else {
        $sectionSteps.find('.section__inner').css('min-height', mainHeight);
    }
}


function enablePointerButton() {
    $('.checkbox-avoid-click').each(function () {
        $(this).on('change', function (event) {
            if ($(this).is(':checked')) {
                $('[data-checkbox-target="' + $(this).attr('id') + '"]').removeClass('avoid-clicks');
                $(this).closest('.checkbox').removeClass('error');
            } else {
                $('[data-checkbox-target="' + $(this).attr('id') + '"]').addClass('avoid-clicks');
                $(this).closest('.checkbox').addClass('error');
            }
        });
    });
    $('.avoid-clicks').each(function () {
        var checkboxes = $('#' + $(this).attr('data-checkbox-target'));
        checkboxes.closest('.checkbox').removeClass('error');
        $(this).on('click', function (event) {
            event.preventDefault();
            var checkboxes = $('#' + $(this).attr('data-checkbox-target'));
            if (checkboxes.is(':checked')) {
                window.location = $(this).attr('href');
                checkboxes.closest('.checkbox').removeClass('error');
            } else {
                checkboxes.closest('.checkbox').addClass('error');
                return false;
            }
        });
    });


}


/**
 * Init locaiton autocomplete.
 * @param  {object} $autocomplete JQuery Object
 */
window.handleLocationAutocomplete = function () {
    var autocompleteField = document.querySelectorAll('.js-location-autocomplete');
    var options = {
        componentRestrictions: {country: 'fr'}
    };
    for (var i = 0; i < autocompleteField.length; i++) {
        window.autocomplete = new google.maps.places.Autocomplete(autocompleteField[i], options);
        // Limite les champs retournés par google pour limiter le volume et la facture
        window.autocomplete.setFields(['address_components','formatted_address', 'geometry', 'name']);
    }

    autocomplete.addListener('place_changed', function () {
        if (autocomplete.getPlace()) {
          jQuery('#field-address').removeClass('check-address');
          jQuery('.js-location-autocomplete').closest('.form__controls').removeClass('error empty');
          disko.handlePlaceChange(autocomplete.getPlace());
        }
    });
}

/**
 * Handle geolocation.
 */
function handleGeolocation($geolocationBtn, $geolocationField) {
    $geolocationBtn.each(function () {
        $(this).on('click', function (event) {
            event.preventDefault();

            getGeolocation();
        });
    });

    /**
     * Get the city name using geoloction.
     */
    function getGeolocation() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var geolocatedLat = position.coords.latitude;
                var geolocatedLng = position.coords.longitude;
                var geolocatedLatLng = new google.maps.LatLng(geolocatedLat, geolocatedLng);
                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({'location': geolocatedLatLng}, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[0]) {

                            $geolocationField.val(results[0].formatted_address);

                            window.autocomplete.set('place', results[0]);

                            $('.btn-location').addClass('btn-form-hide');
                            $('.btn-remove-location').removeClass('btn-form-hide');

                            window.handleFormItemAnimation();

                            //$('.js-init-validation').addClass('active');
                        } else {
                            //console.log("No reverse geocode results.");
                        }
                    } else {
                        //console.log("Geocoder failed: " + status);
                    }
                });
            });
        } else {
            //console.log("Browser doesn't support geolocation!");
        }
    }
}

/**
 * Init google map.
 */
window.markers = [];
window.initMap = function (container, mapLocations, clusterer, lat, lng) {
    var $this = container;
    var selectedMarker, selectedInfoWindow, currentLocationMarker;
    var centerLat = lat != null ? lat : parseFloat($this.data('lat'));
    var centerLng = lng != null ? lng : parseFloat($this.data('lng'));
    var zoomOption = $this.attr('data-zoom') ? $this.data('zoom') : 13;
    var zoomControl = $this.attr('data-zoom-control') ? $this.data('zoom-control') : false;
    var fullscreenControl = $this.attr('data-fullscreen-control') ? $this.data('fullscreen-control') : true;
    var streetViewControl = $this.attr('data-streetview-control') ? $this.data('streetview-control') : true;
    var markerIcon = $this.data('marker-icon');
    var markerSelectedIcon = $this.data('selected-marker-icon');
    var markerLocation = $this.data('location-marker-icon');
    var markerLocationLat = $this.data('location-lat');
    var markerLocationLng = $this.data('location-lng');
    var mapInfoBox = $this.data('infobox-template');
    var infoBoxTemplate = $(mapInfoBox).html();
    var myLatLng = {lat: centerLat, lng: centerLng};
    var bounds = new google.maps.LatLngBounds();
    var $btnFitBounds = $('.js-fit-map-bounds');

    if (!$('.choose__center').hasClass('active')) {
        if ('undefined' !== typeof window.markers) {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
        }
        window.markers = [];
    }

    var mapStyle = [
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#444444"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
                "color": "#f2f2f2"
            }]
        }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{
                "saturation": -100
            }, {
                "lightness": 45
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{
                "visibility": "simplified"
            }]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "transit.station",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        }, {
            "featureType": "transit.station.bus",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }, {
            "featureType": "transit.station.rail",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        }, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{
                "color": "#aad2e3"
            }, {
                "visibility": "on"
            }]
        }
    ];

    var mapOptions = {
        center: myLatLng,
        zoom: zoomOption,
        mapTypeId: google.maps.MapTypeId.roadmap,
        scrollwheel: false,
        zoomControl: zoomControl,
        fullscreenControl: fullscreenControl,
        streetViewControl: streetViewControl,
        styles: mapStyle
    };

    if (typeof $this.attr('data-disable-maptype') != typeof undefined) {
        mapOptions['mapTypeControl'] = false;
    }
    var icon = {
        url: markerIcon,

        scaledSize: new google.maps.Size(28, 34)
    };

    var selectedIcon = {
        url: markerSelectedIcon,

        scaledSize: new google.maps.Size(28, 34)
    };

    if ($this.attr('data-show-location')) {
        var officeIcon = {
            url: markerLocation,

            scaledSize: new google.maps.Size(35, 40)
        };
    }
    var currentLocationLatLng = new google.maps.LatLng(markerLocationLat, markerLocationLng);

    window.map = new google.maps.Map($this[0], mapOptions);

    if ($this.attr('data-show-location') && markerLocationLat !== null && markerLocationLng !== null) {
        var currentLocationMarker = new google.maps.Marker({
            position: currentLocationLatLng,
            map: map,
            icon: officeIcon
        });

        bounds.extend(currentLocationMarker.position);
    }

    if (mapLocations && mapLocations.length > 0) {
        $.each(mapLocations, function (key, data) {
            var latLng = new google.maps.LatLng(data.latitude, data.longitude);
            var marker = new google.maps.Marker({
                position: latLng,
                map: map,
                icon: icon
            });
            marker.data = data;
            markers.push(marker);

            bounds.extend(marker.position);
            //map.fitBounds(bounds);

            if ($this.attr('data-infobox-template')) {
                var template = Handlebars.compile(infoBoxTemplate);
                var infoContent = template(data);
                var infoWindow = new InfoBox({
                    content: infoContent,
                    maxWidth: 0,
                    alignBottom: true,
                    pixelOffset: new google.maps.Size(0, -43),
                    closeBoxURL: disko_ajax_object.template_uri + '/assets/images/ico-cross.png',
                    zIndex: 9999
                });

                if ($('#offers-list').length > 0) {
                    marker.addListener('click', function () {
                        for (var markerIdx = 0; markerIdx < markers.length; markerIdx++) {
                            if (markers[markerIdx] === this) {
                                if (selectedMarker && selectedInfoWindow != null && selectedInfoWindow.getMap() != null) {
                                    selectedMarker.setIcon(selectedIcon);
                                    selectedInfoWindow.close();
                                } else if (selectedInfoWindow == infoWindow) {
                                    selectedInfoWindow = null;
                                }

                                markers[markerIdx].setIcon(icon);
                                selectedMarker = markers[markerIdx];
                                selectedInfoWindow = infoWindow;
                                selectedInfoWindow.open(map, markers[markerIdx]);
                            } else {
                                markers[markerIdx].setIcon(selectedIcon);
                            }
                        }

                    });
                } else {

                }

                google.maps.event.addListener(infoWindow, 'domready', function () {
                    centerInfoBox($this, map, selectedMarker);
                    Completude.InitHtmlComponent();
                });

                google.maps.event.addListener(infoWindow, 'closeclick', function () {
                    // resetMarker();
                    for (var markerIdx = 0; markerIdx < markers.length; markerIdx++) {
                        markers[markerIdx].setIcon(icon);
                    }

                });

                if ($this.attr('data-fit-bounds')) {
                    google.maps.event.addDomListener(window, 'resize', function () {
                        if (typeof map !== 'undefined') {
                            map.fitBounds(bounds);
                        }
                    });
                }
            }

            if ($("#page_agence").length>0) {
                // Page mon-agence
                marker.addListener('click', function () {
                    var $marker = this;
                    document.location = $marker.data.link;
                });
            }
        });
        google.maps.event.addListener(map, 'click', function (event) {
            if (selectedInfoWindow) {
                selectedInfoWindow.close();
                for (var markerIdx = 0; markerIdx < markers.length; markerIdx++) {
                    markers[markerIdx].setIcon(icon);
                }
                // resetMarker();
            }
        });

        if (clusterer) {
            let clusterStyles = [
                {
                    textColor: 'white',
                    url: disko_ajax_object.template_uri + '/assets/images/marker-cluster1.png',
                    width: 40,
                    height: 47,
                    textSize: 15
                }
            ];
            let mcOptions = {
                maxZoom: 13,
                styles: clusterStyles
            };
            let markerCluster = new MarkerClusterer(map, markers, mcOptions);
        }
    } else {
        if (!isNaN(myLatLng.lat) && !isNaN(myLatLng.lng)) {
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: icon
            });
            // markers.push(marker);
        }

        if (!$('.google-map').attr('data-zoom')) {
            bounds.extend(marker.position);
            map.fitBounds(bounds);
        }
    }

    $btnFitBounds.on('click', function () {
        if (!isNaN(bounds.Lat)) {
            map.fitBounds(bounds);
        }

        if ($('.infoBox').length) {
            centerInfoBox($this, map, selectedMarker);
        }
    });

    function resetMarker() {
        selectedMarker.setIcon(icon);
        for (var markerIdx = 0; markerIdx < markers.length; markerIdx++) {
            markers[markerIdx].setIcon(icon);
        }
    }

    function centerInfoBox($container, map, selectedMarker) {
        map.setCenter(selectedMarker.getPosition());

        if ($container.attr('data-infobox-offset-x')) {
            map.panBy(-$container.data('infobox-offset-x'), -($('.infoBox').outerHeight() / 2));
        } else {
            map.panBy(0, -($('.infoBox').outerHeight() / 2));
        }
    }
};

window.tagManager = function (element, where) {
    try {  // Virtual Page View avec GoogleTagManager
        if (typeof element.attr('data-tag-manager-page-title') != typeof undefined) {
            dataLayer.push({
                'event': 'VirtualPageview',
                'virtualPageURL': element.attr('data-tag-manager-title') + '-' + element.attr('data-tag-manager-page-title'),
                'virtualPageTitle': (typeof element.attr('data-tag-manager-page-custom-title') != typeof undefined) ? element.attr('data-tag-manager-page-custom-title') : element.attr('data-tag-manager-page-title')
            });
        }
    } catch (ex) {
        console.log('exception', ex);
    }

}


/**
 * Init tooltips.
 */
function initTooltip() {
    tippy('.btn-tooltip');
}

/**
 * Init custom scrollbar.
 * @param  {object} $customScrollbarContainer JQuery Object
 */
function initCustomScrollbar($customScrollbarContainer) {
    var typeScrollBar = $customScrollbarContainer.attr('data-type-scrollbar') ? $customScrollbarContainer.data('type-scrollbar') : 'y';
    var scrollBarAxis = typeScrollBar;

    switch (typeScrollBar) {
        case 'vertical':
            scrollBarAxis = "y";

            break;
        case 'horizontal':
            scrollBarAxis = "x";

            break;
        case 'both':
            scrollBarAxis = "yx";

            break;
    }

    $customScrollbarContainer.mCustomScrollbar({
        axis: scrollBarAxis
    });
}



/**
 * Init popups functionality.
 */
function initPopups() {
    $('.js-popup-init').magnificPopup({
        type: 'inline'
    });
}

/**
 * Handle form item animation.
 */
window.handleFormItemAnimation = function () {
    var $formItem = $('.js-animate-form-item');
    $formItem.each(function () {
        var $this = $(this);
        var $container = $this.closest('.form__controls');

        if (!$this.is('input')) {
            switch (true) {
                case $this.is('.dropdown'):
                    if ($this.hasClass('open')) {
                        $container.addClass('animate-label');
                    } else {
                        if ($container.find('.dropdown__placeholder').html() !== '') {
                            $container.addClass('animate-label');
                        } else {
                            $container.removeClass('animate-label');
                        }

                    }

                    break;
                case $this.is('.select'):
                    if (!$this.find('.placeholder').hasClass('selected') && !$this.parents('.form__controls').hasClass('form-item__disabled') && $this.find('select').val() !== '') {
                        $container.addClass('animate-label');
                    } else {
                        $container.removeClass('animate-label');
                    }

                    break;
            }
        } else {
            if ($this.val() !== '') {
                $container.addClass('animate-label');
            }
        }

        $this.on('focusin', function () {
            if ($(this).closest('form').hasClass('form-mobile') && !$(this).closest('form').hasClass('active')) {
                $(this).closest('.form-mobile').addClass('active');
            }
            if (!$this.is('input') && !$this.is('textarea')) {
                if ($this.find('.placeholder').hasClass('selected')) {
                    $container.addClass('animate-label');
                }
            } else {
                if ($this.val() === '') {
                    $container.addClass('animate-label');
                }
            }
        }).on('focusout', function () {
            if ($this.closest('.form-mobile__field')) {
                $('.js-sticky-item').find('.sticky-item__inner').removeClass('hide');
            }
            if (!$this.is('input') && !$this.is('textarea')) {
                if ($this.find('.placeholder').hasClass('selected')) {
                    $container.removeClass('animate-label');
                }
            } else {
                if ($this.val() !== '') {
                    $container.addClass('animate-label');
                } else {
                    $container.removeClass('animate-label');
                }
            }
        });
    });
}

/**
 * Handle promo code functionality.
 */
function handlePromoCode() {
    function toggleClasses(condition, $fieldContainer, errorClass) {
        if (condition) {
            $fieldContainer.addClass(errorClass);
        } else {
            $fieldContainer.removeClass(errorClass);
        }
    }

    $('#field-code').keyup(function (event) {
        if (event.keyCode === 13) {
            $('.btn-promo-code').click();
        }
    });

    $('.btn-promo-code').on('click', function (event) {
        event.preventDefault();
        tagManager($(this), 'promoClick');
        var $parentContainer = $(this).closest('#promo-code-content').find('.form__controls');
        var hasValue = $(this).closest('#promo-code-content').find('#field-code').val() !== '';
        var emptyClass = 'empty';

        toggleClasses(!hasValue, $parentContainer, emptyClass);

        if (hasValue) {
            if (null != window.getItemLocalStorage('bookingData')) {
                dataFormApply = JSON.parse(window.getItemLocalStorage('bookingData'));
            }

            var src = $(this).data('src');

            dataFormApply.code = $(this).closest('#promo-code-content').find('#field-code').val();

            var code = $(this).closest('#promo-code-content').find('#field-code').val();

            if (code == 0) {
                code = 'CODE0';
            }

            var payload = {
                'promo': code,
                'stage': dataFormApply.stage,
                'class': dataFormApply.class,
                'courses1': (typeof dataFormApply.courses1 != typeof undefined) ? dataFormApply.courses1 : '',
                'courses0': dataFormApply.courses0,
               // 'partner': dataFormApply.partner,
                'agency_phone': (typeof dataFormApply.agency_phone != typeof undefined) ? dataFormApply.agency_phone : '',
                'agency_label': (typeof dataFormApply.agency_label != typeof undefined) ? dataFormApply.agency_label : '',
                'booking_period_title': dataFormApply.booking_period_title,
                'booking_subject_label': dataFormApply.booking_subject_label,
                'booking_period_place': dataFormApply.booking_period_place,
                'shortDate': dataFormApply.shortDate

            }

            var target = $('.promo-code');
            $.ajax({
                url: src,
                type: 'get',
                data: payload,
                beforeSend: function () {
                    addLoader(target);
                },
                success: function (response) {
                    $('.loader').hide();
                    $(target).removeClass('nopointer');
                    if (response.success && typeof response.data.ws_data != typeof undefined) {
                        dataFormApply.hasCost = true;
                        dataFormApply.costData = response.data.ws_data;

                        if (null != response.data.ws_data.CodePartenaire) {
                            //override partnerID
                            //window.setItemLocalStorage('partner_id', response.data.ws_data.UrlPartenaire);
                            window.setCookie('partner', response.data.ws_data.CodePartenaire);
                            //dataFormApply.partner = response.data.ws_data.CodePartenaire;
                        } else {

                            //dataFormApply.partner = null;
                            //window.removeItemLocalStorage('partner_id');
                            window.deleteCookie('partner');
                        }
                        target.html(response.data.tpl);
                        $('[data-price]').html(dataFormApply.costData.NewPrice + '€ <span class="ttc">TTC</span>');
                        $('[data-old-price]').html(dataFormApply.costData.TarifStage + '€ <span class="ttc">TTC</span>');
                        $('.course-commentaires').html(dataFormApply.costData.CommentairesParticipationCe);
                        if (dataFormApply.costData.NewPrice != dataFormApply.costData.TarifStage) {
                            $('[data-old-price]').removeClass('hide');
                        } else {
                            $('[data-old-price]').addClass('hide');
                        }
                        if (dataFormApply.costData.MontanReductionFidelite > 0) {
                            dataFormApply.promo = code;
                        } else {
                            dataFormApply.promo = null;
                        }
                        window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));
                    }
                }
            }).done(function () {

                Completude.InitHtmlComponent();
                handleDataMapping();
                handleFormValidation($('#form-config'));
                target.addClass('show-code');
                handlePromoCode();
            });
        }
    });

    /**
     * Annule le code de reduction partenaire
     */
    $('.cancel-code').on('click', function (event) {
        event.preventDefault();
        tagManager($(this), 'cancelcode');
        if (null != window.getItemLocalStorage('bookingData')) {
            dataFormApply = JSON.parse(window.getItemLocalStorage('bookingData'));
        }

        $('#field-code').val();
        dataFormApply.code = null;
        dataFormApply.promo = null;

        var src = $(this).data('src');
        var dataAgency = JSON.parse(window.getItemLocalStorage('bookingData'))
        var payload = {
            'promo': null,
            'stage': dataFormApply.stage,
            'agency': dataFormApply.agency,
            'bookingData': JSON.parse(window.getItemLocalStorage('bookingData')),
            'class': dataFormApply.class,
            'partner' : '',
            'courses1': (typeof dataFormApply.courses1 != typeof undefined) ? dataFormApply.courses1 : '',
            'courses0': dataFormApply.courses0,
            'duration': dataFormApply.duration,
            'coursesLabel0': dataFormApply.coursesLabel0,
            'coursesLabel1': dataFormApply.coursesLabel1,
            'centerAddress': dataFormApply.centerAddress,
            'agency_phone': (typeof dataFormApply.agency_phone != typeof undefined) ? dataFormApply.agency_phone : '',
            'agency_label': (typeof dataFormApply.agency_label != typeof undefined) ? dataFormApply.agency_label : '',
            'booking_period_title': dataFormApply.booking_period_title,
            'booking_subject_label': dataFormApply.booking_subject_label,
            'booking_period_place': dataFormApply.booking_period_place,
            'shortDate': dataFormApply.shortDate
        }

        var target = $($(this).data('target'));
        $.ajax({
            url: src,
            type: 'get',
            data: payload,
            beforeSend: function () {
                addLoader(target);
            },
            success: function (response) {
                $('.loader').hide();

                $(target).removeClass('nopointer');
                if (response.success && typeof response.data.ws_data != typeof undefined) {
                    dataFormApply.hasCost = true;
                    dataFormApply.costData = response.data.ws_data;
                    if (null != response.data.ws_data.CodePartenaire) {
                        //override partnerID
                        //window.setItemLocalStorage('partner_id', response.data.ws_data.UrlPartenaire);
                        window.setCookie('partner', response.data.ws_data.CodePartenaire);
                        //dataFormApply.partner = response.data.ws_data.CodePartenaire;
                    } else {
                        //dataFormApply.partner = null;
                        //window.removeItemLocalStorage('partner_id');
                        window.deleteCookie('partner');
                    }

                    //console.log(target)
                    $(target).html(response.data.tpl);

                    jQuery('*[data-handlebars]').each(function () {
                        var template = Handlebars.compile(jQuery(this).html());

                        var result = disko.handlebarsFunctions.decodeHTML(template(disko.handlebarsFunctions.handleBarData));
                        jQuery(this).html(result).show();
                    });
                    window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));
                    $('[data-price]').html(dataFormApply.costData.NewPrice + '€ <span class="ttc">TTC</span>');
                    $('[data-old-price]').html(dataFormApply.costData.TarifStage + '€ <span class="ttc">TTC</span>');
                    $('.course-commentaires').html(dataFormApply.costData.CommentairesParticipationCe);
                    if (dataFormApply.costData.NewPrice != dataFormApply.costData.TarifStage) {
                        $('[data-old-price]').removeClass('hide');
                    } else {
                        $('[data-old-price]').addClass('hide');
                    }
                }
            }
        }).done(function () {
            Completude.InitHtmlComponent();
            handleDataMapping();
            handleFormValidation($('#form-config'));
            handlePromoCode();

            jQuery('.data-table-handlebars').each(function () {
                var template = Handlebars.compile(jQuery(this).html());

                var result = disko.handlebarsFunctions.decodeHTML(template(disko.handlebarsFunctions.handleBarData));
                jQuery('.timetable').html();
                jQuery('.timetable').html(result);
                jQuery(this).html(result).show();
            });
        });
        window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));
    });
}

window.pagingDots = $('.progress-step');
function handleDataMapping() {
    $('[data-mapping]').unbind('click');
    $('[data-mapping]').on('click', function (e) {
        if ($('form')[0].id === 'form-config') {
            mappingFormConfig(this);
        }
    });

    if ($('[data-booking-continue]').length) {
        var element = $('[data-booking-continue]');
        element.attr('data-mapping', element.attr('data-booking-continue'));
        element.removeAttr('data-booking-continue');
        if (null == window.getItemLocalStorage('bookingData')) {
            window.location = '/';
        }
        mappingFormConfig(element);
    }

    if ($('[data-set-title]').length) {
        if (null != window.getItemLocalStorage('bookingData') || null != window.getItemSessionStorage('config-search')) {
            var dataFormApply = JSON.parse(window.getItemLocalStorage('bookingData')) || {};
            var configSearch = window.getQueryParameters(window.getItemSessionStorage('config-search'));

            jQuery.each($('[data-set-title]'), function () {
                dataFormApply.booking_period_title = $(this).html();
                $('body').attr('data-booking-period-title', dataFormApply.booking_period_title);
                $('body').attr('data-booking-period-place', dataFormApply.booking_period_place);
                dataFormApply.booking_period_place = configSearch['field-city'] + ' - ' + configSearch['field-class-label'];

                var title = '';
                if (dataFormApply.booking_period_title != undefined) {
                    title = dataFormApply.booking_period_title + ' <br/> ';

                }

                if (dataFormApply.booking_period_place != undefined) {
                    title = title + dataFormApply.booking_period_place;
                }

                if (title != '') {
                    $(this).html(title);
                }
                window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));
                $(this).removeAttr('data-set-title');
            });
        }
    }

    if ($('.init-manager').length) {

        tagManager($('.init-manager'), 'init-configurator');
        $('.init-manager').removeClass('init-manager')
    }
}

/**
 * Handle steps functionality.
 */
window.handleSteps = function () {

    var data = window.getItemSessionStorage('completude-data');
    var formStep = $('.form__step.active');
    data = JSON.parse(data);

    if ($('.form__steps').length) {
        var steps = new Steps({
            steps: '[data-step-index]',
            container: document.querySelector('.form__steps')
        });
        if ($('[data-class-id]').length > 0) { //access cost form from home
            steps.activeIndex = 1;
            //toggleStory.push('#0');
            if (toggleStory.indexOf('#1') < 0) {
                toggleStory.push('#1');
                toggleStory = cleanArray(toggleStory);
            }
            //
            //window.location = '#1';
            // $('[data-class-id]').
        }
        window.steps = steps;
    }

    if (data != null) {
        if (typeof data['field-subject'] != typeof undefined) {
            var link = $('ul.list-btns.list-courses.ajax-subject');
            var childrens = link.children('li');
            if (childrens.length > 0) {
                childrens.each(function (index) {
                    var a = $(this).children('a');
                    if (a.data('courseId') == data['field-subject']) {
                        //a.css('color', '#fff');
                        //a.css('background', '#637280');
                        //a.addClass('active-el');
                        $('#field-subject').val(a.data('course-id'));
                        $('#field-subject-label').val(a.text());
                    }
                });
            }
            var link = $('ul.list-btns.list-courses.ajax-subject-secondary');
            var childrens = link.children('li');
            if (childrens.length > 0) {
                childrens.each(function (index) {
                    var a = $(this).children('a');
                    if (a.data('courseId') == data['field-subject']) {
                        //a.css('color', '#fff');
                        //a.css('background', '#637280');
                        a.addClass('active-el');
                        $('#field-subject').val(a.data('course-id'));
                        $('#field-subject-label').val(a.text());
                        $('.link-accordion-expander').trigger('click');
                    } else {
                        a.removeClass('active-el');
                    }
                });
            }
        }
    }
    $('.form__step .list-courses a:not("[data-mapping]")').unbind('click');
    $('.form__step .list-courses a:not("[data-mapping]")').on('click', function (event) {


        tagManager($(this).closest('.form__step'), 'listeocurse');
        event.preventDefault();
        $('#field-subject').val($(this).data('course-id'));
        $('#field-subject-label').val($(this).text());
        $(this).addClass('active-el');
        $('.form__step .list-courses a:not([data-course-id=' + $(this).data('course-id') + '])').removeClass('active-el');
        $('.field-class-label').val($('.field-class option:selected').text());

        if (typeof undefined != typeof $(this).closest('ul').data('target-ajax')) {

            var payload = {
                'field-subject': $(this).data('course-id'),
                'field-subject-label': $(this).text(),
                'field-class': $('.field-class').val(),
                'field-class-label': $('.field-class option:selected').text(),
                'field-address': $('#field-address').val(),
                'field-map-lat': $('#field-map-lat').val(),
                'field-map-lng': $('#field-map-lng').val(),
            }
            var target = $(this).closest('ul').data('target-ajax');
            if ($(document).find('#nbProfs').length) {
                $('#nbProfs').remove();
                $(target).parent().addClass('hide');
            }
            getData($(this).closest('ul').data('src'), $(this).parent(), target, payload);
        }

        // if ($('#form-cost').length > 0) {
        //     var cur = parseInt($(".form__step.active").data("step-index")) + 1;
        //     if ($('[data-class-id]').length == 0) {
        //         toggleStory.push("#" + $(".form__step.active").data("step-index"));
        //     }
        //     window.location = "#" + cur;
        //     toggleStory.push("#" + cur);
        //     toggleStory = cleanArray(toggleStory);
        //     isToggleStep = true;
        //     updateisToggleStep();

        // }
        toggleSteps(steps, 'next', 'listocurse');
        if (!$(this).attr('data-disable-paging')) {
            var currentStepIndex;
            if ($(this).data('paging-active-index') === undefined) {
                currentStepIndex = $(this).closest('.form__step').data('paging-active-index');
            } else {
                currentStepIndex = $(this).data('paging-active-index');
            }
            updatePaging(steps, currentStepIndex, pagingDots);
        }

        hideStepsElements();
    });
    $('.btn-error-class').unbind('click');
    $('.btn-error-class').on('click', function (e) {
        e.preventDefault();

        var data = window.getItemSessionStorage('completude-data');
        data = JSON.parse(data);
        // if ($(this).hasClass('btn-error-class-gonext')) {
        //     if ($('.checkbox--expand.js-checkbox-expand.open').length > 0 && $('.checkbox--expand.js-checkbox-expand.open').length === $('.checkbox--expand.js-checkbox-expand > [type="checkbox"]:checked').length) {//.checkbox--expand.js-checkbox-expand [type="checkbox"]:checked + label::after
        //         toggleSteps(steps, 'next', 'btn-error-class');
        //     } else {
        //         if ($('.checkbox--expand.js-checkbox-expand [type="checkbox"]:checked').length > 0) {
        //             $('.error-form-classes-2').addClass('visible');
        //             $('.error-form-classes').removeClass('visible');
        //             $(this).blur();
        //         } else {
        //             $('.error-form-classes-2').removeClass('visible');
        //             $('.error-form-classes').addClass('visible');
        //             $(this).blur();
        //         }
        //     }
        // } else {
            var href = $(location).attr('href');
            var target = 'demande-de-tarifs';
            if (data !== null) {
                if (href.indexOf(target) != -1) {
                    if (typeof data['field-subject'] != typeof undefined && typeof data['field-subject-label'] != typeof undefined) {
                        //toggleSteps(steps, 'next', 'btn-error-class-else');
                    }
                }
            }

            var formStep = $(this).closest('.form__step');

            if (0 == formStep.find('.active-el').length) {
                $('.error-form-classes').addClass('visible');
                $(this).blur();
            } else {
                formStep.find('.active-el')[0].click();
            }
        //}
        return false;
    });
    handleDataMapping();
    hideStepsElements();
}

function hideStepsElements() {
    if ($('.form__step.active:not(.js-fakeactive)').hasClass('hide-progress')) {
        $('.progress-steps').css('display', 'none');
    } else {
        $('.progress-steps').css('display', 'flex');
    }

    if ($('.form__step.active:not(.js-fakeactive)').hasClass('hide-form-header')) {
        $('.form-steps .form__head').addClass('hide');
    } else {
        $('.form-steps .form__head').removeClass('hide');
    }
}

window.isToggleStep = false;

window.toggleSteps = function (steps, moveTo, where) {

    if (moveTo === 'next') {
        steps.next();
        isToggleStep = true;
        updateisToggleStep();
        window.Completude.TagManagerTunnel();
    } else if (moveTo === 'prev') {
        steps.prev();
        isToggleStep = true;
        updateisToggleStep();
    } else {
        steps.to(moveTo); // moveTo should be the index of existing step
        isToggleStep = true;
        updateisToggleStep();
        window.Completude.TagManagerTunnel();
    }
    $('.error-form-classes').removeClass('visible');
    $("html, body").animate({
        scrollTop: 0
    }, 500);
}

// function updatePaging(steps, currentStepIndex, pagingDots) {
//     pagingDots.each(function (dotIndex, dot) {
//         if ($('.form__step').attr('data-paging-active-index')) {
//             if (dotIndex == currentStepIndex) {
//                 $(dot).addClass('active');
//
//                 var $step = $('#form-config').find('.choose__center');
//                 if ($step.hasClass('active')) {
//                   initMapExpander();
//                 }
//
//             } else {
//                 $(dot).removeClass('active');
//             }
//         } else {
//             if (dotIndex == steps.activeIndex) {
//                 $(dot).addClass('active');
//             } else {
//                 $(dot).removeClass('active');
//             }
//         }
//     });
// }

window.updatePaging = function (steps, currentStepIndex, pagingDots) {

    pagingDots.each(function (dotIndex, dot) {
        //$(dot).addClass('active');
        if (currentStepIndex > 0) {
            if (dotIndex > 0) {
                $(dot).removeClass('active');
                if (dotIndex == currentStepIndex) {
                    $(dot).addClass('active');
                }
            } else {
                $(dot).removeClass('active');
            }
        } else {
            if (dotIndex == 0) {
            }
        }

        if ($('.form__step').attr('data-paging-active-index')) {
            if(jQuery('.custom-stage-progress-bar').length > 0){
                jQuery('.progress-step').each(function( index ) {
                    jQuery( this ).removeClass('active');
                });
                if(currentStepIndex == 0){
                    jQuery( '.step0-stage' ).addClass('active');
                }

                if(currentStepIndex == 1 || isNaN(currentStepIndex)){
                    jQuery( '.step1-stage' ).addClass('active');
                }
            }
            if (dotIndex == currentStepIndex) {

                var $step = $('#form-config').find('.choose__center');
                if ($step.hasClass('active')) {
                    if (jQuery('.box-course .collapsed-content').length == 1) {
                        if (jQuery('.box-course .collapsed-content').hasClass('expand')) {

                        } else {
                            initMapExpander();
                        }

                    } else {
                        initMapExpander();
                    }

                }

            }

        }

    });
}

window.getQueryParameters = function (str) {
    var result = (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
        return n = n.split("="), this[n[0]] = n[1], this
    }.bind({}))[0];
    if ('object' == typeof result) {
        jQuery.each(result, function (key, value) {
            result[key] = encodeURI(value);
        });
    }

    return result;
}


/**
 *
 * @param element
 */
window.addLoader = function (element) {
    var loader = document.createElement('div');
    $(loader).addClass('loader');
    $(loader).css('margin', '20px auto 0 auto');
    for (var i = 0; i < 12; i++) {
        $("<div></div>").appendTo($(loader));
    }
    $(element).find('.loader').remove();
    $(element).addClass('nopointer');
    if ($(element).is(':button')) {
        $(loader).insertAfter($(element));
    } else {
        $(loader).appendTo($(element));
    }
}

function handleFormValidationOnFocus($form) {
    var fields = $form.find('[required],[data-validate]');
    var $parentContainer = $('.field-class').closest('.form__controls')

    //setTimeout(function(){
    $(fields).each(function (index) {
        $(this).focusout(function () {
            $(fields).each(function (index) {
                if ($(this).val() != '' && $(this).attr('id') != 'field-terms') {

                    if ($(this).attr('id') != 'field-address') {
                        validateFormItems($(this), $(this).closest('.form__controls'));
                    }

                    /*if(jQuery('#field-map-lat').val() == '' && $(this).attr('id') == 'field-address'){
                        //console.log('empty so error')
                        //checkFieldValidation($( this ), $( this ).closest('.form__controls'));
                        jQuery('#field-address').closest('.form__controls-inner').addClass('empty')
                        jQuery('#field-address').closest('.form__controls').addClass('error')
                    }

                    if(jQuery('#field-map-lat').val() != '' && $(this).attr('id') == 'field-address'){
                        //console.log('empty so error')
                        //checkFieldValidation($( this ), $( this ).closest('.form__controls'));
                        jQuery('#field-address').closest('.form__controls-inner').removeClass('empty')
                        jQuery('#field-address').closest('.form__controls').removeClass('error')
                    }*/
                }
            });
        });
    });
    //}, 200);


}

/**
 * Custom text inputs validation.
 * @param  {object} fields JQuery Object
 */
function handleFormValidation($form) {
    var src = $form.data('src');
    var target = $form.data('target');
    var fields = $form.find('[required],[data-validate],[data-check-limit]');
    var buttons = $form.find('.js-button-toggle');
    var loadedContainer = $form.data('loaded-container');

    var errorClass = 'error';
    var errorClassBis = 'error-bis';
    var errorClassAddress = 'error-address';
    var emptyClass = 'empty';
    $('[data-validate="address"]').unbind('blur');
    $('[data-validate="address"]').on('blur', function () {
        if ($(this).val() != jQuery('#field-map-current-address').val()) {
            window.autocomplete.set('place', false);
            jQuery('#field-map-place-change').val('');
            jQuery('#field-map-current-address').val('');
            jQuery('.location-fields').each(function () {
                jQuery(this).val('');
            });

            //$(this).closest('.form__controls').removeClass(errorClass);
            // toggleClasses(true, $(this).closest('.form__controls'), errorClass);
            toggleCheckAddressField();
        }
    });

    fields.each(function (fieldIdx) {
        var $field = $(this);
        var $nextField = fields.eq(fieldIdx + 1);
        var $parentContainer = $field.closest('.form__controls');

        if ($form.attr('data-field-stepper')) {
            $form.find('[data-disabled]').addClass('disabled');

            if (fieldIdx !== 0) {
                disableField($parentContainer);
            }
        }

        if (isField($field)) {
            if ('form-config' == $form.attr('id')) {
                $field.unbind('keyup');
            }
            if ($field.is('textarea')) {
                $field.on('keyup', function () {
                    var max = $field.attr('maxlength');
                    var len = $(this).val().length;
                    if (len >= max) {
                        $($field.closest('.form__controls-inner').find('.charNum')).html('0 caractère restant');
                    } else {
                        var char = max - len;
                        $($field.closest('.form__controls-inner').find('.charNum')).html(char + ' caractères restants');
                    }
                });
            } else if ($('textarea').hasClass('textarea-option')) {
                $field = $('textarea');
                $field.on('keyup', function () {
                    var max = $field.attr('maxlength');
                    var len = $(this).val().length;
                    if (len >= max) {
                        $($field.closest('.form__controls-inner').find('.charNum')).html('0 caractère restant');
                    } else {
                        var char = max - len;
                        $($field.closest('.form__controls-inner').find('.charNum')).html(char + ' caractères restants');
                    }
                });
            }
            $field.on('input', function () {
                //$parentContainer.removeClass(emptyClass);
                //validateFormItems($field, $parentContainer);

                if ($form.hasClass('js-get-form-data')) {
                    $form.parent().removeClass('data-loaded');
                }

                if ($form.attr('data-field-stepper')) {
                    handleFormStepper($(this), $nextField);
                }
            });
        } else if (isFormBtnGroup($field)) {
            var $formBtnGroupContainer = $field.closest('[data-validate="formBtnGroup"]');

            $field.on('change', function () {
                isFormBtnGroupValid($form, $formBtnGroupContainer);
            });
        } else if (isFormBtnGroupConfig($field)) {
            var $formBtnGroupContainer = $field.closest('[data-validate="formBtnGroupConfig"]');
            $field.on('change', function () {
                isFormBtnGroupConfigValid($form, $field, $formBtnGroupContainer);

            });
        } else {
            $field.on('selectric-open', function () {
                $parentContainer.removeClass(emptyClass).addClass('animate-label');
                $sectionOffers.addClass('zindexoffers');
            });

            $field.on('selectric-close', function () {
                var hasValue = $(this).val() !== '';
                toggleClasses(!hasValue, $parentContainer, emptyClass);
            });

            $field.on('selectric-change', function () {
                validateFormItems($field, $parentContainer);
                if ($form.hasClass('js-get-form-data')) {
                    $form.parent().removeClass('data-loaded');
                }
                if ($form.attr('data-field-stepper')) {
                    handleFormStepper($(this), $nextField);
                }
            });
        }
    });

    handleFormAction();
    handleChecboxesConfig();
    enablePointerButton();

    function handleFormStepper($element, $nextField) {
        if ($element.closest('.form__controls').hasClass('animate-label')) {
            enableField($nextField.closest('.form__controls'));
        } else {
            disableField($nextField.closest('.form__controls'));
        }

        enableFormSubmitButton(fields.closest('.form__controls'), $('[data-disabled]'));
    }

    window.validateFormItems = function ($field, $fieldContainer) {
        var hasValue = $field.val() !== '';
        toggleClasses(!hasValue, $fieldContainer, emptyClass);

        if ($fieldContainer.hasClass('form-item__disabled')) {
            $fieldContainer.addClass('emptyClass');
        }

        var nullValue = $field.val() == '0' || $field.val() == '00';
        toggleClasses(nullValue, $fieldContainer, errorClass);

        if ($field.data('validate') === 'phone') {
            fieldPhone($field, $fieldContainer);
        } else if ($field.data('validate') === 'mobile') {
            fieldMobile($field, $fieldContainer);
        } else if ($field.data('validate') === 'email') {
            fieldEmail($field, $fieldContainer);
        } //else if ($field.data('validate') === 'year') {
        //     fieldYear($field, $fieldContainer);
        // }
        else if ($field.data('validate') === 'text') {
            fieldText($field, $fieldContainer);
        // else if ($field.data('validate') === 'day') {
        //     fieldDay($field, $fieldContainer);
        // } else if ($field.data('validate') === 'month') {
        //     fieldMonth($field, $fieldContainer);
        } else if ($field.data('validate') === 'address') {
            $('#field-address').addClass('check-address');
        } else {
            checkFieldValidation($field, $fieldContainer);
        }

        // if ($field.data('verifydate') === true) {
        //     verifyDate($field, $fieldContainer);
        // }
    }

    function isField($field) {
        if ($field.is('input:not(:radio):not(:checkbox)') || $field.is('textarea')) {
            return $field;
        }
    }

    function isFormBtnGroup($field) {
        if ($field.attr('data-validate') == 'formBtnGroup') {
            return $field;
        }
    }

    function isFormBtnGroupConfig($field) {
        if ($field.attr('data-validate') == 'formBtnGroupConfig') {
            return $field;
        }
    }

    function isCheckbox($field) {
        if ($field.attr('data-validate') == 'checkbox') {
            return $field;
        }
    }

    function isFormBtnGroupValid($form, $fieldBtnItems) {
        var isChecked = $fieldBtnItems.find('input:checked').length > 0;

        if (isChecked) {
            $form.find('[data-disabled="true"]').removeClass('disabled');
        } else {
            $form.find('[data-disabled="true"]').addClass('disabled');
        }

        toggleClasses(!isChecked, $fieldBtnItems, errorClass);
    }

    function isFormBtnGroupConfigValid($form, $fieldBtnItems) {
        var max = ($fieldBtnItems.find('input').length < $fieldBtnItems.data('max-courses')) ? $fieldBtnItems.find('input').length : $fieldBtnItems.data('max-courses');

        var isChecked = $fieldBtnItems.find('input:checked').length > 0;
        var maxChecked = $fieldBtnItems.find('input:checked').length >= max;
        var btn = $form.find('[data-disabled="true"]');
        var allDisabled = ($fieldBtnItems.find('input[type="checkbox"]:enabled').not(':checked').length == 0 && $fieldBtnItems.find('input[type="checkbox"]:enabled:checked').length == 1)

        if (isChecked || allDisabled) {
            btn.removeClass('disabled');
        } else {
            btn.addClass('disabled');
        }

        if (maxChecked || allDisabled) {
            btn.removeClass('js-popup-init');
            btn.unbind('click');
            btn.attr('href', '#');
            btn.attr('data-mapping', 'step3');
            handleDataMapping();
            $fieldBtnItems.find('input:enabled').not(':checked').addClass('disable-max').attr('disabled', 'disabled');
        } else {
            btn.removeAttr('data-mapping');
            btn.attr('href', '#popup-msg' + $fieldBtnItems.data('min-courses'));

            btn.addClass('js-popup-init');
            isToggleStep = true;
            initPopups();
            $fieldBtnItems.find('.disable-max').not(':checked').removeAttr('disabled').removeClass('disable-max');
        }

        toggleClasses(!isChecked, $fieldBtnItems, errorClass);
    }

    function checkFieldValidation($field, $fieldContainer) {
        if ($field.val() == 0) {
            $fieldContainer.removeClass(errorClass);
        } else if ($field.attr('data-validate') && !isCheckbox($field) && !isFormBtnGroup($field)) {
            var typeElement = $field.data('validate');
            toggleClasses(!validateField($field, typeElement, $field.val()), $fieldContainer, errorClass);
        } else if (isCheckbox($field)) {
            $fieldContainer = $field.closest('.checkbox');
            toggleClasses(!$field.is(':checked'), $fieldContainer, errorClass);
        }
    }

    function fieldEmail($field, $fieldContainer) {
        var emailValue = $field.val();
        var typeElement = $field.data('validate');
        var isValidEmail = validateField($field, typeElement, emailValue);
        if ($field.val() == '') {
            $fieldContainer.removeClass(errorClass);
        } else {
            toggleClasses(!isValidEmail, $fieldContainer, errorClass);
        }
    }

    function fieldPhone($field, $fieldContainer) {
        var caretPosition = $field[0].selectionStart;
        var phoneValue = $field.val().split(new RegExp('[-./ ]', 'g')).join('');
        var typeElement = $field.data('validate');
        var isValidPhone = validateField($field, typeElement, phoneValue);

        if ($field.val() == '') {
            $fieldContainer.removeClass(errorClass);
        } else if ($field.val() === '0000000000') {
            $fieldContainer.addClass(errorClass);
        } else {
            toggleClasses(!isValidPhone, $fieldContainer, errorClass);
        }

    }

    // function fieldDay($field, $fieldContainer) {
    //     var dateValue = $field.val();
    //     var typeElement = $field.data('validate');
    //     var isValidDate = validateField($field, typeElement, dateValue);

    //     if ($field.val() == '0' || $field.val() == '00') {
    //         $fieldContainer.addClass('error');
    //     } else if ($field.val() == 0) {
    //         $fieldContainer.removeClass(errorClass);
    //     } else {
    //         toggleClasses(!isValidDate, $fieldContainer, errorClass);
    //     }
    // }

    // Validates that the input string is a valid date formatted as "mm/dd/yyyy"
    function checkDateIsValideString(dateString) {
        // First check for the pattern
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
            return false;

        // Parse the date parts to integers
        var parts = dateString.split("/");
        var day = parseInt(parts[1], 10);
        var month = parseInt(parts[0], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month == 0 || month > 12)
            return false;

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    };

    // function verifyDate($field, $fieldContainer) {
    //     var dateValue = $field.val();
    //     var typeElement = $field.data('validate');
    //     var isValidDate = validateField($field, typeElement, dateValue);
    //     var $formRow = $fieldContainer.closest('.form__row');
    //     var day = $formRow.find('.form__controls-inner input#field-birth-day').val();
    //     var $dayContainer = $formRow.find('.form__controls-inner input#field-birth-day').closest('.form__controls');
    //     var $monthContainer = $formRow.find('.form__controls-inner input#field-birth-month').closest('.form__controls');
    //     var month = $formRow.find('.form__controls-inner input#field-birth-month').val();
    //     var year = $formRow.find('.form__controls-inner input#field-birth-year').val();
    //     var test;

    //     if (isValidDate && (day.length == 2) && (month.length == 2) && (year.length == 4)) {
    //         test = month + "/" + day + "/" + year;
    //         test = checkDateIsValideString(test);
    //         if (!test) {
    //             toggleClasses(!test, $dayContainer, errorClass);
    //             toggleClasses(!test, $monthContainer, errorClass);
    //         } else {
    //             toggleClasses(!test, $dayContainer, errorClass);
    //             toggleClasses(!test, $monthContainer, errorClass);
    //         }
    //     }
    // }

    // function fieldMonth($field, $fieldContainer) {
    //     var monthValue = $field.val();
    //     var typeElement = $field.data('validate');
    //     var isValidMonth = validateField($field, typeElement, monthValue);

    //     if ($field.val() == '0' || $field.val() == '00') {
    //         $fieldContainer.addClass('error');
    //     } else if ($field.val() == 0) {
    //         $fieldContainer.removeClass(errorClass);
    //     } else {
    //         toggleClasses(!isValidMonth, $fieldContainer, errorClass);
    //     }
    // }

    function fieldMobile($field, $fieldContainer) {
        var typeElement = $field.data('validate');
        var phoneValue = $field.val().split(new RegExp('[-./ ]', 'g')).join('');
        var isValidPhone = validateField($field, typeElement, phoneValue);

        if ($field.val() == '') {
            $fieldContainer.removeClass(errorClass);
        } else {
            toggleClasses(!isValidPhone, $fieldContainer, errorClass);
        }

    }

    function fieldText($field, $fieldContainer) {
        var fieldValue = $field.val().length;
        var min = 2;
        var max = 513;
        var isValid = (fieldValue >= min) && (fieldValue < max);
        var isEmpty = fieldValue == 0;

        if (!isValid && (isEmpty == false)) {
            toggleClasses(!isValid, $fieldContainer, errorClass);
        } else if (isEmpty == true) {
            $fieldContainer.removeClass(errorClass);
        } else {
            var typeElement = $field.data('validate');
            var isValidText = validateField($field, typeElement, $field.val());
            if (!isValidText) {
                toggleClasses(!isValidText, $fieldContainer, errorClass);
            }
        }
    }

    window.initAddress = function ($field, $fieldContainer, $button) {
        $fieldContainer.removeClass(errorClass);
        var placeFromStorage = window.getItemLocalStorage('completude-save-place');

        if (0 != $('[data-validate="address"]').length && $button != null) {
            if (!$button.hasClass('check-address-on-submit')) {
                return;
            }
        }

        if (0 == $('[data-validate="address"]').length || !placeFromStorage) {
            return;
        }
        window.autocomplete.set("place", JSON.parse(placeFromStorage));
    }
    window.checkAddress = function ($field, $fieldContainer, $button) {

        if (0 != $('[data-validate="address"]').length && $button != null && !$button.hasClass('check-address-on-submit')) {
            return;
        }

        if (0 == $('[data-validate="address"]').length) {
            return;
        }

        var isValid = (('true' == jQuery('#field-map-place-change').val()) || ('true' == jQuery('#field-map-place-change').val())) && $field.val().length > 3;

        if ((!isValid) && $field.val().length > 3) {
            jQuery('#field-map-place-change').val('');
            window.removeItemLocalStorage('completude-save-place');
            $('[for="field-address"]').removeClass(errorClass);
            $($fieldContainer).removeClass(errorClass);
            $('[for="field-address"]').removeClass(emptyClass);
            $($fieldContainer).removeClass(emptyClass);
            toggleClasses(!isValid, $('[for="field-address"]'), errorClass);
            toggleClasses(!isValid, $fieldContainer, errorClass);
            return;
        } else {
            toggleGeolocMobile();
            $('[for="field-address"]').removeClass(errorClass);
            $($fieldContainer).removeClass(errorClass);
            $('[for="field-address"]').removeClass(emptyClass);
            $($fieldContainer).removeClass(emptyClass);
            if ($field.val() == 0) {
                toggleClasses(!isValid, $('[for="field-address"]'), emptyClass);
                toggleClasses(!isValid, $fieldContainer, emptyClass); //here
            } else {
                toggleClasses(!isValid, $('[for="field-address"]'), errorClass);
                toggleClasses(!isValid, $fieldContainer, errorClass);
            }
            return;
        }

    }

    // function fieldYear($field, $fieldContainer) {
    //     var currentYear = new Date().getFullYear();
    //     var yearValue = $field.val();
    //     var min = $field.data('min');
    //     var max = $field.data('max');
    //     var isValidYear = (currentYear - yearValue) > min;
    //     var isValidYearMax = (currentYear - yearValue) > max;
    //     var isEmpty = yearValue.length == 0;

    //     if (yearValue > (currentYear - min)) {
    //         $('.error-msg').removeClass('active-error');
    //         toggleClasses(yearValue > (currentYear - min), $fieldContainer, errorClass);
    //         $('.error-minimum').addClass('active-error');
    //     } else if (yearValue < (currentYear - max) && yearValue > 0) {
    //         $('.error-msg').removeClass('active-error');
    //         toggleClasses(yearValue < (currentYear - max) && (yearValue > 0), $fieldContainer, errorClass);
    //         $('.error-sup').addClass('active-error');
    //     } else if (isEmpty == true) {
    //         $('.error-msg').removeClass('active-error');
    //         $fieldContainer.removeClass('errorClass');
    //     } else if (yearValue == 0) {
    //         toggleClasses(yearValue == 0, $fieldContainer, errorClass);
    //         $('.error-minimum').addClass('active-error');
    //     } else {
    //         checkFieldValidation($field, $fieldContainer);
    //     }

    // }

    function validateField($field, type, value) {
        return new RegExp(getRegExp($field, type)).test(value);
    }

    function toggleClasses(condition, $fieldContainer, errorClass) {

        if (condition && !$fieldContainer.hasClass('form-item__disabled')) {
            // $fieldContainer.removeClass(errorClassBis).removeClass(errorClass).addClass(errorClass);
            $fieldContainer.removeClass(errorClassBis).removeClass(errorClass).removeClass(errorClassAddress).addClass(errorClass);
            var $parent = $fieldContainer.closest('.form__controls__birtherror');
            if ($parent.length) {
                $parent.removeClass('errorBirth').addClass('errorBirth');
            }
        } else {
            $fieldContainer.removeClass(errorClass).removeClass(errorClassBis).removeClass(errorClassAddress).removeClass('error');
            var $parent = $fieldContainer.closest('.form__controls__birtherror');
            if ($parent.length) {
                var er1 = $parent.find('.error');
                var er2 = $parent.find('.empty');
                if (!er1.length && !er2.length) {
                    $parent.removeClass('errorBirth');
                }
            }
        }
    }

    /**
     *
     * @param $form
     */
    function mappingStagesFields($form) {
        var action = $form.attr('action');
        window.setItemSessionStorage('config-search', $form.serialize());
        var data = $form.serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});
        var mapping = {
            'field-class': 'IdClasse', 'agency': 'IdAgence',
            'field-subject': 'IdMatiere', 'field-period': 'IdPeriode', 'repeating': 'repeating'
        };
        var char = '&';
        var modifyaction = false;
        $.each(mapping, function (index, value) {
            if (typeof data[index] != typeof undefined && data[index].length > 0) {
                char = '&';
                if (action.indexOf("?") == -1) {
                    char = '?';
                }
                action = action + char + value + '=' + data[index];
                modifyaction = true;
            }
        });

        window.location = action;

        return;
    }

    function handleFormAction() {
        buttons.each(function () {
            var button = $(this);

            button.on('click', function (event) {
                event.preventDefault();
                let formValidatedWithParsley = ['form-apply'];
                if (formValidatedWithParsley.includes($(this).closest('form').prop('id'))) {
                    return;
                }

                var moveToStep = button.data('move-to');
                var inputRequired = [];
                var $this = $(this);
                if ($(this).closest('.form__step').find('[required]').length) {
                    inputRequired = $(this).closest('.form__step').find('[required]');
                } else if ($(this).closest('.form__step').length == 0) {
                    inputRequired = $(this).closest('form').find('[required]');
                }
                if (inputRequired.length > 0) {
                    inputRequired.each(function () {
                        var $field = $(this);
                        var $parentContainer = $field.closest('.form__controls');

                        validateFormItems($field, $parentContainer);

                        if (isFormBtnGroup($field)) {
                            var $formBtnGroupContainer = $field.closest('[data-validate="formBtnGroup"]');

                            isFormBtnGroupValid($form, $formBtnGroupContainer);
                        }
                    });
                }
                checkAddress($('[data-validate="address"]'), $('[data-validate="address"]').closest('.form__controls'), button);
                // if ($('#form-cost').length > 0) {
                //     //window.location = "#"+$(".form__step.active").data("step-index");
                //     window.location = "#" + (parseInt($(".form__step.active").data("step-index")) + 1);
                //     toggleStory.push("#" + $(".form__step.active").data("step-index"));
                //     toggleStory = cleanArray(toggleStory);
                //     isToggleStep = true;
                //     updateisToggleStep();
                // }

                if ($form.find('.error').length == 0 && $form.find('.empty').length == 0) {

                    if ($(this).hasClass('btn-disable-after-click')) {
                        $(this).prop("disabled", true);
                    }

                    //var submitFilter = $('#filter-offer').find(".btn-to-submit-filter");
                    var event = jQuery.Event("submit");
                    //submitFilter.trigger(event);
                    window.processUser($form.serializeArray());
                    var buttonType = button.attr('type');
                    var formParent = $form.closest("form");
                    if (!button.attr('data-move-to')) {
                        if (buttonType === 'submit') {
                            if (!$form.parent().hasClass('data-loaded')) {
                                $doc.find($(loadedContainer)).remove();
                            }
                            if ("undefined" == typeof (button.attr('data-submit'))) {
                                $form.parent().addClass('submitted');
                                getData(src, $form.parent(), $(target), $form.serialize());
                            } else {
                                switch (formParent.attr('id')) {
                                    case 'send-message':
                                        // processContact(formParent);
                                        break;
                                    case 'callback-request':
                                        // processCallback(formParent);
                                        break;
                                    //case 'search-offer':
                                    default:
                                        if (!button.hasClass('block-submit')) {
                                            // if ($('.js-materials').hasClass('visible')) {
                                            //     formParent.find('div.dropdown__backdrop.js-toggle-dropdown').trigger('click');
                                            // }
                                            formParent.submit();
                                        }
                                        if (button.hasClass('mapping-before-send')) {
                                            mappingStagesFields(formParent);
                                        }
                                        break;
                                }
                            }
                            tagManager(button, 'handleFormAction');
                        }
                    } else {
                        if (buttonType === 'submit' && !button.hasClass('no-submit')) {
                            var formParent = $form.closest("form");
                            window.processUser(formParent.serializeArray());
                            switch (formParent.attr('id')) {
                                // case 'form-cost':
                                //     processFormCost(formParent);
                                //     break;
                                // case 'form-ask-prof':
                                //     processAskProf(formParent);
                                //     break;
                                case 'form-config':
                                    processFormConfig(formParent);
                                    break;
                            }
                        }
                        if (button.hasClass('check-place')) {
                            return false;
                        }
                        if (!button.data('mapping') && !button.hasClass('btn-step-back') && !button.hasClass('btn-back')) {
                            tagManager(button, 'handleFormAction');
                            toggleSteps(window.steps, moveToStep);

                            if ($('#form-apply').length > 0) {
                                window.location = "#" + $(".form__step.active").data("step-index");
                                toggleStory.push("#" + $(".form__step.active").data("step-index"));
                                // stepHistory.push(parseInt($(".form__step.active").data("step-index")));
                                if ($(".form__step.active").data("step-index") === 10) {
                                    stepHistory.push(parseInt($(".form__step.active").data("step-index")) - 1);
                                }
                                toggleStory = cleanArray(toggleStory);
                                isToggleStep = true;
                                updateisToggleStep();
                            }
                        }
                    }
                }

                if ($form.find('.error').length || $form.find('.empty').length && $('#search-form').length === 0) {

                    var invalidInputs = [];
                    var input = {};
                    var id,
                        pos;

                    $('.error, .empty').each(function () {

                        id = $(this).find('input, textarea').attr('id');
                        pos = $(this).find('input, textarea').offset();
                        input = {id: id, pos: pos}
                        invalidInputs.push(input);
                    });

                    if (invalidInputs.length > 0) {

                        // const firstEl = invalidInputs.reduce(
                        //   (min, p) =>
                        //     p.pos.top < min
                        //       ? p.pos.top
                        //       : min, invalidInputs[0].pos.top
                        // );
                        // const first = invalidInputs.find( el => el.pos.top === firstEl);

                        let first = invalidInputs[0];

                        $('html,body').animate({
                            scrollTop: $("#" + first.id).offset().top - 200
                        }, 'slow');
                    }

                    if (($('#form-cost').length > 0 && !$('#form-cost').hasClass('no-scroll')) || ($('.form-cpg').length > 0 && !$('.form-cpg').hasClass('no-scroll'))) {
                        if (!$('#field-terms').parent().hasClass('error')) {
                            $('html,body').animate({
                                scrollTop: $('form').not('.no-scroll').offset().top
                            }, 'slow');
                        }
                    }
                }

                updateSectionStepHeight();

                hideStepsElements();

                if ($('#form-cost').length > 0 || $('#form-ask-prof').length > 0) { //$('#form-apply').length > 0 ||
                    window.location = "#" + $(".form__step.active").data("step-index");
                    toggleStory.push("#" + $(".form__step.active").data("step-index"));
                    toggleStory = cleanArray(toggleStory);
                    isToggleStep = true;


                    /* TODO --
                        Ajout pour faire en sorte que les etapes et la validation se fasse correctement
                    */
                    if( typeof window.step_index === 'undefined') {
                        window.step_index = $(".form__step.active").data("step-index");
                        let el = jQuery('#field-terms2').closest('.checkbox')

                        el.removeClass('error')
                        el.find('ul.parsley-errors-list').remove();
                    }

                    //on clear toute les étapes
                    $('.progress-steps .progress-step').removeClass('active');
                    //on définit l'étape active
                    let el = $('.progress-steps .progress-step');

                    if( el[ $(".form__step.active").data("step-index") ] != undefined) {
                        jQuery( el[ $(".form__step.active").data("step-index") ] ).addClass('active')
                    }


                    updateisToggleStep();
                }

                if (!button.attr('data-disable-paging') && typeof steps != typeof undefined) {
                    var currentStepIndex = $('.form__step.active').data('paging-active-index');
                    updatePaging(steps, currentStepIndex, pagingDots);
                }

            });
        });
    }

    function getRegExp($field, type) {
        switch (type) {
            case 'text':
                return '^([ \u00c0-\u01ffa-zA-Z\'\\-])+$';

            case 'email':
                return '^[0-9a-zA-Zäåö]+([0-9a-zA-Zäåö]*[-._+])*[0-9a-zA-Zäåö]+@[0-9a-zA-Zäåö]+([-.][0-9a-zA-Zäåö]+)*([0-9a-zA-Zäåö]*[.])[a-zA-Zäåö]{2,6}$';

            case 'phone':
                return '^(((0))[0-9]{9})$';

            case 'day':
                return '^\s*(3[01]|[12][0-9]|0?[1-9])\s*$';

            case 'month':
                return '(^0?[1-9]$)|(^1[0-2]$)';

            case 'year':
                return '^[0-9]*$';

            case 'mobile':
                return '^0[67]\\d{8}$';

            case 'pattern':
                return $field.attr('data-pattern');

            default:
                return 'Invalid field validation';
        }
    }
}

/**
 * Enable form submit button.
 * @param  {object} $formItems  JQuery Object
 * @param  {object} $formSubmit JQuery Object
 * @return {[type]}             [description]
 */
function enableFormSubmitButton($formItems, $formSubmit) {
    if ($formItems.length === $formItems.filter('.animate-label').length) {
        $formSubmit.removeClass('disabled');
    } else {
        $formSubmit.addClass('disabled');
    }
}


// /**
//  * Handle toggle elements.
//  * @param  {object} $items JQuery Object
//  */
// function handleToggleElements($items) {
//     if ($items.length) {
//         $items.each(function () {
//             var $this = $(this);

//             $this.find('a:not(.js-custom-modal-toggle)').on('click', function (event) {
//                 event.preventDefault();
//                 var $link = $(this);
//                 var $siblings = $link.parent().siblings().find('a');

//                 var target = $link.data('target');
//                 var customClass = $link.data('custom-class');
//                 var siblingsTarget = $siblings.data('target');

//                 $(target).removeClass(customClass);

//                 $link.parent().addClass('active').siblings().removeClass('active');

//                 if ($link.parent().hasClass('active')) {
//                     $(target).addClass(customClass);
//                     $(siblingsTarget).removeClass(customClass);
//                 }
//             });
//         });
//     }
// }

// /**
//  * Handle custom modal functionality.
//  */
// function handleCustomModal() {
//     var $modalLink = $('.js-custom-modal-toggle');

//     if ($modalLink.length) {
//         $modalLink.on('click', function (event) {
//             event.preventDefault();
//             var modalTarget = $(this).data('modal-target');

//             $('.main').addClass('visible');
//             $(modalTarget).addClass('visible');
//             //lockScroll($(modalTarget));
//         });
//     }
// }

// function handleFilterSubmitButton() {
//     var $filterSubmitButton = $('#filter-offer').find('.btn-to-submit-filter');
//     $filterSubmitButton.on('click', function (event) {
//         $(this).closest('[data-closable-item]').removeClass('visible');
//         $(this).closest('[data-closable-item]').find('.google-map').removeAttr('style');
//         lockScroll($(this));
//     });
// }

// /**
//  * Handle custom close functionality.
//  */
// function handleCloseItem() {
//     $('[data-close-item]').on('click', function (event) {
//         event.preventDefault();

//         $(this).closest('[data-closable-item]').removeClass('visible');
//         $(this).closest(".main.visible").removeClass('visible');

//         $(this).closest('[data-closable-item]').find('.google-map').removeAttr('style');
//         //lockScroll($('[data-closable-item]'));
//     });
// }

/**
 * Handle sticky item funcionality.
 * @param  {object} $stickyItem   JQuery Object
 * @param  {number} winScrollTop
 * @param  {number} winHeight
 */
function handleStickyItem($stickyItem, winScrollTop, winHeight) {
    var formStickyActionTop = $stickyItem.offset().top;
    var formStickyActionHeight = $stickyItem.outerHeight();
    var scrollTop = winScrollTop;
    var isSticky = scrollTop + winHeight > formStickyActionTop + formStickyActionHeight;

    $(window).scroll(function () {
        var y = $(this).scrollTop();
        if (y > 560) {
            $('.apply-sticky-action').removeClass('sticky-item__inner--hide');
        } else {
            $('.apply-sticky-action').addClass('sticky-item__inner--hide');
        }
    });

    $('[data-always-sticky]').css('z-index', 30).closest('section').css('z-index', 20);

    if ($('[data-index-sticky]').length > 0) {
        $('[data-index-sticky]').css('z-index', 30).closest('section').css('z-index', 50);
    }

    for (var i = 0; i < $stickyItem.length; i++) {
        if (!$($stickyItem[i]).attr('data-always-sticky') === "") {
            $($stickyItem[i]).css('min-height', $($stickyItem[i]).find('> div').outerHeight());
            $($stickyItem[i]).toggleClass('stick', isSticky);
        } else {
            $('body').addClass('sticky-mobile');
        }
    }
}

/**
 * CLose notice box on click.
 * @return {[type]} [description]
 */
window.closeNotice = function () {
    var $noticeToggle = $('.js-close-notice');
    var $noticeContainer = $noticeToggle.closest('.notice--closable');
    if (sessionStorage.getItem('verifClose') == 'close') {
        $noticeContainer.addClass('notice--hidden');
    }
    var noticeContainerHeight = $noticeContainer.outerHeight();
    var noticePopupId;

    for (var t = 0; t < $noticeContainer.length; t++) {
        var $nC = $($noticeContainer[t]);
        noticePopupId = $nC.data('popup-id');
        if (noticePopupId != 'popup-booking') {
            if (null === window.getItemSessionStorage(noticePopupId) || window.getItemSessionStorage(noticePopupId) === "false") {
                if ($nC.hasClass('notice--modal') && isMobileLayout) {
                    $nC.removeAttr('style');
                    $nC.css('display', 'block');
                } else {
                    $nC.css('top', $header.outerHeight());
                }
            } else {
                $nC.css('display', 'none');
            }
        }
    }

    $noticeToggle.on('click', function (event) {
        event.preventDefault();
        window.setItemSessionStorage(noticePopupId, true);
        $noticeContainer.addClass('notice--hidden');
        var verifClose = 'close';
        sessionStorage.setItem('verifClose', verifClose);
        sessionStorage.setItem('closeModal', 'notice--hidden');
    });
}

/**
 * Handle load more functionality.
 * @param  {object} $element JQuery Object
 * @return {[type]}          [description]
 */
function handleLoadMore($element) {
    var src = $element.data('src');
    var target = $element.data('target');
    var loadedContainer = $element.data('loadedContainer');

    $element.on('click', function (event) {
        event.preventDefault();
        var offset = null;
        var payload = null;
        if (typeof $(this).data('offset') != typeof undefined) {
            offset = $(this).data('offset');
            var limit = $(this).data('limit');
            var total = $(this).data('total');
            var current = $(this).data('current');
            payload = {
                'offset': offset,
                'limit': limit,
                'total': total,
                'current': current
            }
        }

        $(this).closest('.section').removeClass('data-loaded');
        getData(src, $(this).closest('.section'), $(target), payload);

        if (null != offset) {
            current++;
            offset = current * limit;
            if (current > total) {
                $(this).addClass('hide');
            }
            $(this).data('current', current);
            $(this).data('offset', offset);
        }
    });
}

/**
 * Init custom video player.
 * @param  {HTML Element} playerItem
 * @return {[type]}            [description]
 */
function initCustomVideoPlayer(playerItem) {
    var videoPoster = $(playerItem).data('poster');
    var player = new Plyr(playerItem);

    setTimeout(function () {
        player.poster = videoPoster;
    }, 500);
}

function initSliders() {
    var $slider = $('.js-slider');

    $slider.slick({
        infinite: true,
        mobileFirst: true,
        dots: true,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
    });
}

window.isExpired = function (currentDate) {
    var expire = new Date(currentDate);
    var exdate = new Date();
    return (!expire || exdate >= expire);
}

/**
 * Set form values with localstorage
 */
function handleFormCompletudeDatas() {
    return ;
    var data = window.getItemLocalStorage('completude-data');
    if (data) {
        data = JSON.parse(data);
        $.each(data, function (key, value) {
            if ($('[name*="' + key + '"]') && !$('[name*="' + key + '"]').hasClass('not-fill')) {
                if ($('[name*="' + key + '"]').is("select")) {
                    $('[name*="' + key + '"] option[value="' + value + '"]').attr("selected", true);
                } else if ($('[name*="' + key + '"]').is(":radio")) {
                    $('[name*="' + key + '"]').val([value]);
                } else {
                    $('[name*="' + key + '"]').val(value);
                }
            }
            if ('field-address' == key && 0 != $('#field-map-current-address').length) {
                $('#field-map-current-address').val(value);
                if ('' != value) {
                    $('#field-map-place-change').val('true');
                }
            }
        });
    }
    var data = window.getItemSessionStorage('completude-data');
    if (data) {
        data = JSON.parse(data);
        $.each(data, function (key, value) {
            if ($('[name*="' + key + '"]') && !$('[name*="' + key + '"]').hasClass('not-fill')) {
                if ($('[name*="' + key + '"]').is("select")) {
                    $('[name*="' + key + '"] option[value="' + value + '"]').attr("selected", true);
                } else if ($('[name*="' + key + '"]').is(":radio")) {
                    $('[name*="' + key + '"]').val([value]);
                } else {
                    $('[name*="' + key + '"]').val(value);
                }
            }
        });
    }
}

/**
 * Initialization of all the functionality.
 */
currentScrollPos = $doc.scrollTop();

/**
 * Initialize of foundation component.
 */
$doc.foundation();

/**
 * Initialize of fields with localestorage datas.
 */
//window.checkExpireDatas();
handleFormCompletudeDatas();
initAnimationFormMobile();

/**
 * Initialize of initCustomSelect functionality.
 */
$customSelect.each(function () {
    var $select = $(this).find('select');

    initCustomSelect($select);
});


/**
 * Initialize of initCustomScrollbar functionality.
 */
$customScrollbar.each(function () {
    initCustomScrollbar($(this));
});

/**
 * Initialize of handleLoadMore functionality.
 */
$loadMore.each(function () {
    handleLoadMore($(this));
});

/**
 * Initialize of displayClass functionality.
 */
displayClass();

/**
 * Initialize of cleanAddressField functionality.
 */
cleanAddressField();

/**
 * Initialize of handleFormItemAnimation functionality.
 */
handleFormItemAnimation();

/**
 * Initialize of initTooltip functionality.
 */
initTooltip();

/**
 * Initialize of initPopups functionality.
 */
initPopups();

/**
 * Initialize of updateSectionStepHeight functionality.
 */
updateSectionStepHeight();

/**
 * Initialize of handlePromoCode functionality.
 */
handlePromoCode();

/**
 * Initialize of handleSteps functionality.
 */
handleSteps();

/**
 * Initialize of handleCustomDropdown functionality.
 */
//handleCustomDropdown();

/**
 * Initialize of handleToggleElements functionality.
 */
//handleToggleElements($toggleElement);

/**
 * Initialize of handleCloseItem functionality.
 */
//handleCloseItem();

/**
 * Initialize of handleFilterSubmitButton functionality.
 */
//handleFilterSubmitButton();

/**
 * Initialize of initSliders functionality.
 */
initSliders();


/**
 * Initialize toggleCheckboxFilterOffer
 */
//toggleCheckboxFilterOffer();

/**
 * Initialize checkFieldTerms
 */
checkFieldTerms();

/**
 * Initialize toggleGeolocMobile
 */
toggleGeolocMobile();

/**
 * Initialize listenBackEvent
 */
listenBackEvent();

/**
 * Initialize toggleLinkCursor
 */
toggleLinkCursor();

/**
 * Initialize show menu popover
 */
showMenuPopover();
/**
 * Initialize of handleExpandableCheckboxes functionality.
 */
$formValidation.each(function () {
    handleFormValidation($(this));
    handleFormValidationOnFocus($(this));
});
/*
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};


var backToOffers = getUrlParameter('offer');

if($('.results-box').length && backToOffers) {

    var headerInner = $('.header').innerHeight();

    function checkOffers() {

        setTimeout(function () {
            if($('#offers-list .result-item').length){
                jQuery('html, body').animate( { scrollTop: jQuery('#' + backToOffers).offset().top - headerInner - 24 }, 400 );
                return true;
            } else {
                checkOffers();
            }
        }, 500);
    }
    checkOffers();

}
*/
$win.on('load scroll', function () {
    currentScrollPos = $doc.scrollTop();
}).on('load resize', function () {
    /**
     * Initialize of checkLayoutType functionality.
     */
    checkLayoutType();

    /**
     * Initialize of closeNotice functionality.
     */
    closeNotice();

    
    winHeight = $win.outerHeight() - $header.outerHeight();

    $(document).ready(function () {
        $wrapper.find('.wrapper__inner').css('padding-top', $header.outerHeight());
    });

    if ($('.js-custom-modal').hasClass('visible')) {
        $('.js-custom-modal').find('.google-map').css('height', $win.outerHeight() - $header.outerHeight());
    }
}).on('load', function () {
    if ($customPlayer.length) {
        /**
         * Initialize of initCustomVideoPlayer functionality.
         */
        $customPlayer.each(function () {
            initCustomVideoPlayer(this);
        });
    }

    if ($locationAutocomplete.length) {
        /**
         * Initialize of form handleLocationAutocomplete functionality.
         */
        handleLocationAutocomplete();
    }

    if ($btnGeolocation.length) {
        /**
         * Initialize of form handleGeolocation functionality.
         */
        handleGeolocation($btnGeolocation, $locationAutocomplete);
    }
   
}).on('resize', function () {

    /**
     * Initialize of form updateSectionStepHeight functionality.
     */
    updateSectionStepHeight();
}).on('load scroll', function () {
    var winScrollTop = $win.scrollTop();
    var winHeight = $win.outerHeight();
    var isHeaderSticky = winScrollTop > 0;

    $stickyItem = $('.js-sticky-item');

    if ($stickyItem.length) {
        /**
         * Initialize of form handleStickyItem functionality.
         */
        handleStickyItem($stickyItem, winScrollTop, winHeight);
    }

    $header.toggleClass('sticky', isHeaderSticky);
});

$win.on('orientationchange', function () {
    setTimeout(function () {
        /**
         * Initialize of closeNotice functionality.
         */
        closeNotice();

        if ($win.outerWidth() >= 320 && $win.outerWidth() <= 767) {
            winHeight = $win.outerHeight() - $header.outerHeight();
            $menuContainer.css('height', winHeight);
        }

        $wrapper.find('.wrapper__inner').css('padding-top', $header.outerHeight());

        if ($('.js-custom-modal').hasClass('visible')) {
            $('.js-custom-modal').find('.google-map').css('height', $win.outerHeight() - $header.outerHeight());
        }
    }, 100);
});


/**
 * DISKO CHANGES
 */

$('[data-btn-payment]').on('click', function (event) {
    tagManager($(this), 'paiement');
});
$(document).on('selectric-change', 'select[id=field-subject]', function () {
    $('#field-subject-label').val($("#field-subject option:selected").text());
}).change();


$('.stopme').parents('form').on('submit', function (e) {
    e.preventDefault();
});

$('.js-button-toggle').on('click', function (e) {

    if ($(this).hasClass('stopme')) {
        e.preventDefault();
    }
    var moveToStep = $(this).data('move-to');
    if ($(this).hasClass('btn-back') || $(this).hasClass('btn-step-back') && !$(this).data('mapping')) {
        toggleSteps(window.steps, moveToStep, 'js-button-toggle');
    }
    if (!$(this).is("[data-mapping]") && !$(this).hasClass('btn-back')) {
        tagManager($('.form__step'), 'js-toogle');
    }
    var currentStep = $('.form__step').attr('data-step-index');

    enableField($('.form__step[data-step-index="' + currentStep + '"] .js-button-toggle'));
    $('.form__step[data-step-index="' + currentStep + '"] .loader').hide();
});

$(window).on('load', function () {
    if (Foundation.MediaQuery.current != 'small') {
        $('#agencies-list .list-link-items .display-agency').on('click', function (e) {
            //e.preventDefault();
        });
    }
});

/**
 *
 */
function initCloseElement() {
    $('.popin-close').on('click', function (event) {
        event.preventDefault();
        $.magnificPopup.close();
    });
    $('.iframe-popin-close').on('click', function (event) {
        event.preventDefault();
        parent.jQuery.magnificPopup.close();
    });
}

initCloseElement();


/**
 *  enable courses checboxes
 */
function handleChecboxesConfig() {
    $('.list-checkboxes input[type="checkbox"]').on('change', function () {
        var $parent = $(this).closest('.list-checkboxes');
        if ($parent.hasClass('course-config')) {
            var timetable = $(this).data('course-timetable');
            var label = $(this).data('course-label');
            if ($(this).is(':checked')) {
                $parent.find('[data-course-timetable="' + timetable + '"]').not(this).attr({
                    disabled: "disabled",
                    checked: false
                });
                $parent.find('[data-course-label="' + label + '"]').not(this).attr({
                    disabled: "disabled",
                    checked: false
                });
            } else {
                $parent.find('[data-course-timetable="' + timetable + '"]').removeAttr('disabled');
                $parent.find('[data-course-label="' + label + '"]').removeAttr('disabled');
            }
            $('[data-course-timetable]:checked').each(function (key, item) {
                var timetable = $(item).data('course-timetable');
                var label = $(item).data('course-label');
                $parent.find('[data-course-timetable="' + timetable + '"]').not($(item)).attr({
                    disabled: "disabled",
                    checked: false
                });
                $parent.find('[data-course-label="' + label + '"]').not($(item)).attr({
                    disabled: "disabled",
                    checked: false
                });
            });
        } else {
            var target = $parent.data('target');
            if ($parent.find('input:checked').length) {
                $(target).removeClass('disabled');
            } else {
                $(target).addClass('disabled');
            }
        }
    });
}



window.processUser = function (formDatas) {
    var fields = [
        'field-title', 'field-lastname', 'field-firstname',
        'field-email', 'field-phone',
        'field-address', 'field-map-address', 'field-map-lng',
        'field-map-lat', 'field-map-city', 'field-map-department',
        'field-map-region', 'field-map-city', 'field-map-postalCode',
        'field-map-formatted-address'
    ];
    var fieldsSession = [
        'field-class-label', 'field-class', 'field-subject', 'field-subject-label'
    ];
    if (window.getItemLocalStorage('completude-data')) {
        var user = JSON.parse(window.getItemLocalStorage('completude-data'));
    } else {
        var user = {};
    }
    if (window.getItemSessionStorage('completude-data')) {
        var userSession = JSON.parse(window.getItemSessionStorage('completude-data'));
    } else {
        var userSession = {};
    }
    $(formDatas).each(function (key, item) {
        if ($.inArray(item.name, fields) > -1) {
            user[item.name] = item.value;
        } else if ($.inArray(item.name, fieldsSession) > -1) {
            userSession[item.name] = item.value;
        }
    });

    if (!jQuery.isEmptyObject(user)) {
        if (typeof window.autocomplete != typeof undefined) {
            if (typeof window.autocomplete.getPlace() != typeof undefined && false != window.autocomplete.getPlace()) {
                window.setItemLocalStorage('completude-save-place', JSON.stringify(window.autocomplete.getPlace()));
                //if ($('.handle-search').length > 0 || $('.handle-search-result').length > 0) {
                window.setItemLocalStorage('completude-save-search-place', JSON.stringify(window.autocomplete.getPlace()));
                //}
            }
        }

        window.setItemLocalStorage('completude-data', JSON.stringify(user));
        //window.setExpireDatas('completude-data', 182.5);
    }

    if (!jQuery.isEmptyObject(userSession)) {
        window.setItemSessionStorage('completude-data', JSON.stringify(userSession));
    }
}

/*  Form - configurator
* @param currentForm
*/
function processFormConfig(src, currentForm, element) {
    $.ajax({
        url: src,
        type: 'post',
        data: currentForm.serialize() + '&' + $.param(dataFormApply),
        beforeSend: function () {
            addLoader(element);
            currentForm.addClass('data-loaded');
        },
        success: function (response) {
            $('.loader').hide();
            $(element).removeClass('nopointer');
            if (response.success && typeof response.data.ws_data != typeof undefined && typeof response.data.ws_data.ErreurMetier == typeof undefined) {
                window.setItemLocalStorage('booking_ws_data', JSON.stringify(response.data.ws_data));
                try {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                       'transactionId'  : response.data.ws_data.IdTransactionStage,
                       'transactionTotal' : response.data.ws_data.TarifStage,
                       'nameProduct' : response.data.ws_data.LibelleStage,
                       'idProduit' : dataFormApply.stage,
                       'priceProduct' :  null,
                       'quantityProduct' : response.data.ws_data.Matiere2!==null ? 2 : 1
                    });
                } catch (e) {

                }

                $('#booking-recap').html(response.data.tpl);

                $('[data-btn-payment]').on('click', function (event) {
                    dataFormApply.hasCost = false;
                    dataFormApply.book = true;
                    tagManager($(this), 'paiement2');
                    window.Completude.TagManagerTunnel('paiementStage/step-2');
                    window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));
                });
                $('[data-price]').html(dataFormApply.costData.NewPrice + '€ <span class="ttc">TTC</span>');
                $('[data-old-price]').html(dataFormApply.costData.TarifStage + '€ <span class="ttc">TTC</span>');
                $('.course-commentaires').html(dataFormApply.costData.CommentairesParticipationCe);
                if (dataFormApply.costData.NewPrice != dataFormApply.costData.TarifStage) {
                    $('[data-old-price]').removeClass('hide');
                } else {
                    $('[data-old-price]').addClass('hide');
                }
                Completude.InitHtmlComponent();
                toggleSteps(window.steps, 'next');
                $("#ws-error").addClass('hide');
                toggleSteps(window.steps, 'next');
                tagManager(element, 'mappingConfig');
                enablePointerButton();
            } else if (typeof response.data != typeof undefined && typeof response.data.ws_data.ErreurMetier != typeof undefined && ('true' == response.data.ws_data.ErreurMetier || true == response.data.ws_data.ErreurMetier)) {
                $("#ws-error").html(response.data.ws_data.Message);
                $("#ws-error").removeClass('hide');
                currentForm.removeClass('data-loaded');
            }
            initPopups();
        },
        done: function () {
            initPopups();
        }
    });
}


/**
 * Ajax Stage Demande de tarif
 * @param {*} element
 * @param {*} formStep
 */
function processFormConfigTarif(element, formStep) {

    Completude.InitHtmlComponent();
    if ($('[data-course-timetable]:checked').length) {
        dataFormApply.courses0 = '';
        dataFormApply.courses1 = '';
        dataFormApply.coursesLabel0 = '';
        dataFormApply.coursesLabel1 = '';
        //dataFormApply.visio = '';
    }
    $('[data-course-timetable]:checked').each(function (key, item) {
        dataFormApply['courses' + key] = $(item).val();
        dataFormApply['coursesLabel' + key] = $(item).data('course-label') + '-' + $(item).data('course-timetable');
        $('.recap-course' + key).find('p').html(dataFormApply['coursesLabel' + key]);
        $('.recap-course' + key).removeClass('hide');
    });

    var src = formStep.data('src');
    var target = formStep.data('target');
    var visio = formStep.data('visio');

    if ($(element).parent().parent().parent().hasClass('popup__actions')) {
        target = $(element).data('target');
        src = $(element).data('src');
        //visio = $(element).data('visio');
        //console.log($(element))
    }

    //dataFormApply.visio = visio;
    var param = '';
    if (typeof dataFormApply.promo != typeof undefined && dataFormApply.promo != null) {
        param = '&continue=1'; //to load ajax_price instead of ajax_promo
    }

    $.ajax({
        url: src,
        type: 'get',
        data: $.param(dataFormApply) + param + '&' +  $.param(window.Completude.GetStorage('completude-analytics')),
        beforeSend: function () {
            if ($(element).is('A')) {
                window.addLoader($(element).parent());
            } else {
                window.addLoader(element);
            }
        },
        success: function (response) {
            $('.loader').hide();
            if ($(element).is('A')) {
                $(element).parent().removeClass('nopointer');
            } else {
                $(element).removeClass('nopointer');
            }
            if (response.success) {

                dataFormApply.hasCost = true;
                window.removeItemLocalStorage('popup-booking'); //to show popup
                $(target).html(response.data.tpl);
                dataFormApply.costData = response.data.ws_data;
                if (null != response.data.ws_data.CodePartenaire) {
                    //override partnerID
                    //window.setItemLocalStorage('partner_id', response.data.ws_data.UrlPartenaire);
                    window.setCookie('partner', response.data.ws_data.CodePartenaire);
                    //dataFormApply.partner = response.data.ws_data.CodePartenaire;
                } else {
                    //dataFormApply.partner = null;
                    //window.removeItemLocalStorage('partner_id');
                    window.deleteCookie('partner');
                }
                $('[data-price]').html(dataFormApply.costData.NewPrice + '€ <span class="ttc">TTC</span>');
                $('[data-old-price]').html(dataFormApply.costData.TarifStage + '€ <span class="ttc">TTC</span>');
                $('.course-commentaires').html(dataFormApply.costData.CommentairesParticipationCe);
                if (dataFormApply.costData.NewPrice != dataFormApply.costData.TarifStage) {
                    $('[data-old-price]').removeClass('hide');
                } else {
                    $('[data-old-price]').addClass('hide');
                }
                window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));

                var stepCurrent = formStep;
                if (formStep.attr('data-tag-manager-page-title') == undefined) {
                    stepCurrent = $('.choose_subject');
                }
                tagManager(stepCurrent, 'mappingConfig');
            }
        }
    }).done(function (response) {
        disko.handlebarsFunctions.template();
        Completude.InitHtmlComponent();
        handleDataMapping();
        $.magnificPopup.close();
        handleFormValidation($('#form-config'));
        handlePromoCode();
        toggleSteps(window.steps, 'next');
        hideStepsElements();
        if($('.step_3_visio').length){
            $('.step_3_visio').hide();
            $('.price-step').show();
        }
    });

}

function getStages(src) {
    if (jQuery('#resultStage').hasClass('data-loaded')) {
        return false;
    }
    $.ajax({
        url: src,
        type: 'get',
        cache: false,
        success: function (response) {
            $('#resultStage').html(response);

            if ($('[data-period-place-ajax]')) {
                var dataFormApply = JSON.parse(window.getItemLocalStorage('bookingData'));
                jQuery.each($('[data-set-title]'), function () {
                    dataFormApply.booking_period_title = $('[data-period-title-ajax]').attr('data-period-title-ajax');
                    dataFormApply.booking_period_place = $('[data-period-place-ajax]').attr('data-period-place-ajax');
                    $('body').attr('data-booking-period-title', dataFormApply.booking_period_title);
                    $('body').attr('data-booking-period-place', dataFormApply.booking_period_place);

                    var title = '';
                    if (dataFormApply.booking_period_title != undefined) {
                        title = dataFormApply.booking_period_title + ' <br/> ';

                    }

                    if (dataFormApply.booking_period_place != undefined) {
                        title = title + dataFormApply.booking_period_place;
                    }

                    if (title != '') {
                        $(this).html(title);
                    }
                    window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));
                    $(this).removeAttr('data-set-title');
                });
            }


            return false;
        },
        beforeSend: function () {
            $('#resultStage').empty();
            addLoader(jQuery('#resultStage'));
            jQuery('#resultStage').addClass('data-loaded');
        }
    }).done(function () {
        $('.loader').hide();
        jQuery('#resultStage').removeClass('nopointer');
        jQuery('#resultStage').removeClass('data-loaded')
        Completude.InitHtmlComponent();
        handleDataMapping();
    });
}

function mappingFormConfig(element) {
    var form = $(element).closest('form');
    var formStep = $(element).closest('.form__step ');
    if (null != window.getItemLocalStorage('bookingData')) {
        dataFormApply = JSON.parse(window.getItemLocalStorage('bookingData'));
    }
    if (typeof $(element).data('mapping') != typeof undefined) {
        switch ($(element).data('mapping')) {
            case 'step0':
                var $parentContainer = $('.field-class').closest('.form__controls');
                validateFormItems($('.field-class'), $parentContainer);
                if (!$parentContainer.hasClass('error') && !$parentContainer.hasClass('empty')) {
                    dataFormApply.repeating = ($('.field-class').val() == $('#field-old-class').val()) ? 1 : 0;
                    var agency = window.getItemLocalStorage('agency_' + $('body').attr('data-agency-id'));
                    if (null != agency) {
                        agency = JSON.parse(agency);
                        dataFormApply.agency_label = agency.label;
                        dataFormApply.agency_phone = agency.parentPhone;
                    }
                    dataFormApply.class = $('.field-class').val();
                    dataFormApply.booking_period_place = dataFormApply.agency_label + ' - ' + $(".field-class option[value='" + dataFormApply.class + "']").text();
                    var title = dataFormApply.booking_period_place;
                    $('[data-replace-title]').html($('[data-booking-period-title]').data('booking-period-title') + '<br/>' + title);
                    $('[data-booking-period-place]').attr('data-booking-period-place', title);
                    getStages($(element).data('src') + '&field-class=' + $('.field-class').val() + '&repeating=' + (dataFormApply.repeating ? 1 : 0));
                    toggleSteps(window.steps, 'next');
                    tagManager(formStep, 'mappingConfig')
                } else {
                    return false;
                }
                break;
            case 'step1':
                //Stage
                window.removeItemSessionStorage('check-course');
                var stageData = JSON.parse($(element).attr('data-stage-data'));
                if (0 == jQuery('#step0').length) {
                    dataFormApply.repeating = -1;
                }
                dataFormApply.post = $('body').data('booking-period-id');
                dataFormApply.booking_period_title = ($('[data-booking-period-title]').length ? $('[data-booking-period-title]').data('booking-period-title') : '');
                dataFormApply.booking_period_place = ($('[data-booking-period-place]').length ? $('[data-booking-period-place]').data('booking-period-place') : '');
                dataFormApply.booking_subject = ($('body').data('booking-subject') ? $('body').data('booking-subject') : '');
                dataFormApply.booking_subject_label = ($('body').data('booking-subject-title') ? $('body').data('booking-subject-title') : '');
                dataFormApply.stage = stageData.id;
                dataFormApply.minCourse = stageData.minCourse;
                dataFormApply.maxCourse = stageData.maxCourse;
                dataFormApply.class = stageData.class;
                dataFormApply.agency = stageData.agency;
                var agency = window.getItemLocalStorage('agency_' + stageData.agency);
                if (null != agency) {
                    agency = JSON.parse(agency);
                    dataFormApply.agency_label = agency.label;
                    dataFormApply.agency_phone = agency.parentPhone;
                }

                dataFormApply.duration = stageData.duration;
                dataFormApply.stageDate = stageData.date;
                dataFormApply.shortDate = stageData.shortDate;
                var payload = {
                    'stage': stageData.id,
                    'agency': stageData.agency,
                    'class': stageData.class,
                    'duration': dataFormApply.duration,
                    'repeating': dataFormApply.repeating,
                }
                var target = formStep.data('target');
                $('.recap-duration p').html(stageData.duration.replace(/\\/g, ''));
                $('.period-title h6').html((dataFormApply.booking_period_title) ? dataFormApply.booking_period_title.replace(/\\/g, '') : '');
                $('.recap-date p').html(stageData.date);
                getData(formStep.data('src'), $(element), $(target), payload);
                Completude.InitHtmlComponent();
                toggleSteps(window.steps, 'next');

                tagManager(formStep, 'mappingConfig')
                break;
            case 'step2':
                //Center
                toggleStory.push(element);

                var centerData = $(element).data('center-data');
                dataFormApply.center = centerData.id;
                dataFormApply.centerAddress = centerData.address.replace(/\\/g, '');
                dataFormApply.agency = centerData.IdAgence;
                dataFormApply.repeating = centerData.repeating;
                dataFormApply.class = centerData.IdClasse;
                dataFormApply.stage = centerData.IdStage;
                dataFormApply.minCourse = centerData.minCourse;
                dataFormApply.maxCourse = centerData.maxCourse;
                dataFormApply.duration = centerData.duration;
                dataFormApply.booking_period_place = centerData.booking_period_place;
                dataFormApply.booking_period_title = centerData.booking_period_title;
                dataFormApply.shortDate = centerData.shortDate;
                var payload = {
                    'center': centerData.id,
                    'centerAddress': centerData.address,
                    'duration': dataFormApply.duration,
                    'stage': centerData.IdStage,
                    //'stage': dataFormApply.stage,
                    'repeating': centerData.repeating,
                    //'repeating': centerData.id,
                    'agency': centerData.IdAgence,
                    //'agency': dataFormApply.agency,
                    'class': centerData.IdClasse,
                    //'class': dataFormApply.class,
                    'minCourse': dataFormApply.minCourse,
                    'maxCourse': dataFormApply.maxCourse,
                }

                var target = formStep.data('target');
                if (!$(element).hasClass('data-loaded')) {
                    $('.btn-choose-center').removeClass('data-loaded');
                    getData(formStep.data('src'), $(element), $(target), payload);
                }
                $('.recap-center p ').html(centerData.address.replace(/\\/g, ''));
                toggleSteps(window.steps, 'next');
                tagManager(formStep, 'mappingConfig');
                window.Completude.TagManagerTunnel('tarifStage/step-2');
                break;
            case 'step3':

                if($('.step_3_visio').length){
                    var stageData = $('.step_3_visio').data('center-data');
                    dataFormApply.center = 0;
                    dataFormApply.repeating = stageData.repeating;
                    dataFormApply.class = stageData.IdClasse;
                    dataFormApply.stage = stageData.IdStage;
                    dataFormApply.minCourse = stageData.minCourse;
                    dataFormApply.maxCourse = stageData.maxCourse;
                    dataFormApply.duration = stageData.duration;
                    dataFormApply.booking_period_place = stageData.booking_period_place;
                    dataFormApply.booking_period_title = stageData.booking_period_title;
                    dataFormApply.shortDate = stageData.shortDate;
                    dataFormApply.visio = 'true';

                    try {
                    dataLayer.push({
                        'event': 'VirtualPageview',
                        'virtualPageURL': 'VoirLeTarif-configurateurDeStages',
                        'virtualPageTitle': 'VoirLeTarif'
                    });
                    } catch (e) {
                        // rien
                    }

                    toggleSteps(window.steps, 'next');
                }
                isToggleStep = true;
                //toggleStory.push(element);

                processFormConfigTarif(element, formStep);
                $('.form__controls').each(function () {
                    $(this).removeClass('error empty');
                });

                window.Completude.TagManagerTunnel('tarifStage/step-3');

                break;
            case 'step4':
                    if($('.step_3_visio').length){
                        dataFormApply.visio = 'true';
                    }
                    $('.checkbox-avoid-click').each(function () {
                        $(this).closest('.checkbox').removeClass('error');
                    });

                    isToggleStep = true;
                    //toggleStory.push(element);
                    handleChecboxesConfig();
                    setTimeout(function () {
                        if (!form.find('.error').length && !form.find('.empty').length) {
                            window.processUser(form.serializeArray());
                            processFormConfig(formStep.data('src'), form, $(element))
                            window.Completude.TagManagerTunnel('resaStage/step-3');
                        }
                    }, 500)
                    break;
            case 'step5':
                isToggleStep = true;
                var centerData = $(element).data('center-data');
                //toggleStory.push(element);
                toggleSteps(window.steps, 'next');
                $('.form__controls').each(function () {
                    $(this).removeClass('empty');
                    $(this).removeClass('error');
                });

                tagManager(formStep, 'mappingConfig');
                window.Completude.TagManagerTunnel('resaStage/step-2');
                setTimeout(function () {
                    if (!$('.resa-step').hasClass('active')) {
                        $(".form__step").each(function (index) {
                            $(this).removeClass('active')
                        });
                        $('.resa-step').addClass('active')
                    }
                }, 250);


                break;
        }
        ;
        window.setItemLocalStorage('bookingData', JSON.stringify(dataFormApply));

        setTimeout(function () {
            var nextStepindex = formStep.data("step-index");
            if (0 == formStep.length && typeof $(element).data('fake-step-index') != typeof undefined) {
                //step 3 popin
                nextStepindex = $(element).data('fake-step-index');
            }
            toggleStory.push("#" + nextStepindex);
            toggleStory = cleanArray(toggleStory);
            window.location = "#" + nextStepindex;
        }, 200);
    }
}

function cleanArray(array) {
    var i, j, len = array.length, out = [], obj = {};
    for (i = 0; i < len; i++) {
        obj[array[i]] = 0;
    }
    for (j in obj) {
        out.push(j);
    }
    return out;
}

function updateisToggleStep() {
    var isToggleStepStime = setTimeout(function () {
        isToggleStep = false;
        clearTimeout(isToggleStepStime);
    }, 1000);
}

function locationHashChanged() {
    if (!isToggleStep) {
        if ($('#form-config').length > 0) {
            var currentStepIndex = $('.form__step.active').data('paging-active-index');
            for (var i = 0; i < toggleStory.length; i++) {
                if (toggleStory[i] === window.location.hash) {
                    if (i === (toggleStory.length - 1)) {
                        toggleSteps(window.steps, 'next');
                        hideStepsElements();
                        updatePaging(window.steps, (currentStepIndex + 1), pagingDots);
                    } else {
                        toggleSteps(window.steps, 'prev');
                        hideStepsElements();
                        updatePaging(window.steps, (currentStepIndex - 1), pagingDots);
                    }
                } else if (window.location.hash === '' && !$('.choose_subject').hasClass('active')) {
                    toggleSteps(window.steps, 0);
                    hideStepsElements();
                    updatePaging(window.steps, (currentStepIndex - 1), pagingDots);
                }
            }
        }

        //WORK FINE
        if ($('#form-cost').length > 0) {
            //var currentStepIndex = $('.form__step.active').data('step-index');
            var currentStepIndex = parseInt($('.form__step.active').data('step-index')) - 1;

            for (var i = 0; i < toggleStory.length; i++) {
                if (toggleStory[i] === window.location.hash) {
                    if (i === (toggleStory.length - 1)) {
                        toggleSteps(window.steps, 'next', 'locationHashChanged 4');
                        hideStepsElements();
                        updatePaging(window.steps, (currentStepIndex + 1), pagingDots);
                    } else {
                        toggleSteps(window.steps, 'prev', 'locationHashChanged 5');
                        hideStepsElements();
                        updatePaging(window.steps, (currentStepIndex - 1), pagingDots);
                    }
                } else if (window.location.hash === '' && $('[data-class-id]').length == 0) {
                    toggleSteps(window.steps, 0, 'locationHashChanged 6');
                    hideStepsElements();
                    updatePaging(window.steps, (currentStepIndex + 1), pagingDots);
                }
            }

            jQuery('.progress-step').each(function( ) {
                jQuery( this ).removeClass('active');
            });
            if(currentStepIndex == 0){
                $('.step0-tarifs').addClass('active');
            }

            if(currentStepIndex == 1){
                $('.step1-tarifs').addClass('active');
            }

            if(currentStepIndex == 2){
                $('.step2-tarifs').addClass('active');
            }
        }

       
        if ($('#form-ask-prof').length > 0) {
            var currentStepIndex = $('.form__step.active').data('paging-active-index');
            for (var i = 0; i < toggleStory.length; i++) {
                if (toggleStory[i] === window.location.hash) {
                    if (i === (toggleStory.length - 1)) {
                        toggleSteps(window.steps, 'next');
                        hideStepsElements();
                        updatePaging(window.steps, (currentStepIndex + 1), pagingDots);
                    } else {
                        toggleSteps(window.steps, 'prev');
                        hideStepsElements();
                        updatePaging(window.steps, (currentStepIndex - 1), pagingDots);
                    }
                } else if (window.location.hash === '') {
                    toggleSteps(window.steps, 0);
                    hideStepsElements();
                    updatePaging(window.steps, (currentStepIndex - 1), pagingDots);
                }
            }

        }

    } else if ($('#form-config').length > 0) {
        if (isToggleStep) {
            var currentStepIndex = $('.form__step.active').data('paging-active-index');
            var h = window.location.hash;
            var p = parseInt(h.substring(1, h.length));
            if (p < currentStepIndex) {
                toggleSteps(window.steps, 'prev');
                hideStepsElements();
                updatePaging(window.steps, (currentStepIndex - 1), pagingDots);
            }
        }
    }
}

function listenBackEvent() {
    if (jQuery('#recap-price').hasClass('active')) {
        window.addEventListener("hashchange", removeParametersUrl, false);
    }
}

function removeParametersUrl() {
    var hashURL = window.location.toString();
    var parameter = hashURL.substring(hashURL.indexOf('?'));
    if (parameter === '?continue=true') {
        window.history.back();
    }
}

function toggleLinkCursor() {
    let links = $('a');
    links.each(function () {
        if ($(this).attr('href') === undefined || $(this).attr('href') === '') {
            $(this).addClass('link--empty');
        }
    });
    onEmptyLinkClick();
}

// function toggleCheckboxFilterOffer() {
//     var filter_offer = $('#filter-offer');
//     var submitFilterOffer = filter_offer.find(".btn-to-submit-filter");
//     var items = $('.list-checkboxes input[type="checkbox"]');

//     submitFilterOffer.on('click', function () {
//         items.each(function () {
//             var item = $(this);
//             if (item.is(":checked") == true) {
//                 item.closest('li').addClass('selected')
//             } else {
//                 item.closest('li').removeClass('selected')
//             }
//         });
//     });
// }

function toggleAccordionArrow() {
    $('.accordion-expander, .box-course').each(function () {
        var $content = $(this).find('.collapsed-content');
        var $title = $(this).find('.link-accordion-expander');
        if ($content.hasClass('expand')) {
            $title.addClass('active');
        }
    });
}

function checkFieldTerms() {
    if ($('#send-message')) {
        $('input:checkbox').on('change', function () {
            if ($(this).prop('required')) {
                if ($(this).prop('checked') == true) {
                    $(this).parent().removeClass('error');
                } else {
                    $(this).parent().addClass('error');
                }
            }
        });
    }
    var $fieldTerms = $('#field-terms');
    $fieldTerms.on('change', function () {
        if ($(this).prop('checked') == true) {
            $fieldTerms.parent().removeClass('error');
        } else {
            $fieldTerms.parent().addClass('error');
        }
    });
}

function initMapExpander() {
    if ($('.collapsed-content .google-map').length === 1) {
        $('.box-course .collapsed-content').toggleClass('expand').stop(true).slideFadeToggle(500, updateSectionStepHeight);
    }
    toggleAccordionArrow();
}

function toggleCheckAddressField() {
    if ($(this).val() == 0) {
        $(this).closest('.form__controls').find('.error-empty').css('display', 'block');
        $(this).closest('.form__controls').find('.error-invalid').addClass('hide');
    } else {
        $(this).closest('.form__controls').find('.error-empty').css('display', 'none');
        $(this).closest('.form__controls').find('.error-invalid').removeClass('hide');
    }
}

function toggleGeolocMobile() {
    if (!$locationAutocomplete.val() == 0) {
        $('.btn-remove-location').removeClass('btn-form-hide');
        $('.btn-location').addClass('btn-form-hide');
    }
    $('.btn-remove-location').on('click', function () {
        $locationAutocomplete.val('');
        $(this).addClass('btn-form-hide');
        $('.btn-location').removeClass('btn-form-hide');
        toggleCheckAddressField();
    });
}

window.onCloseStickyBanner = function () {
    $(document).on('click', '.sticky-item .sticky-item__close', function (e) {
        e.preventDefault();
        var stickyHeight = $('.sticky-item__inner').height();
        $('.sticky-item__inner').animate({
            bottom: -(stickyHeight * 2)
        }, 500, function () {
            $('.sticky-item').addClass('sticky-item--hide');
            sessionStorage.setItem('hide_sticky_banner', true);
        });

    });
}

window.displayStickyBanner = function () {
    if (sessionStorage.getItem('hide_sticky_banner')) {
        $('.sticky-item__toClose').parent().addClass('sticky-item--hide');
    }
}

function onEmptyLinkClick() {
    $(document).on('click', '.link--empty', function (e) {
        e.preventDefault();
    })
}

function openPhonePopup() {
    $('#openPhonePopup').on('click', function () {
        initPopups()
    })
}

function initContactScrollAccordeon() {
    if ($('.section--tabs') && $('.section--tabs').length > 0 && $('.tabs--alt') && $('.tabs--alt').length > 0) {
        let url_string = window.location.href;
        let url = new URL(url_string);
        let type = url.searchParams.get('type');
        if (type != null || type != undefined) {
            let id = '#tab-' + type
            $('html,body').animate({
                scrollTop: $(id).offset().top - 100
            }, 'slow');
        }
    }
}

function initAnimationFormMobile() {
    if ($('form').length > 0) {
        $('form').each(function () {
            if ($(this).hasClass('form-mobile') && !$(this).hasClass('active')) {
                if ($(this).find('input[name="field-address"]').length > 0 && $(this).find('input[name="field-address"]').val().length > 0 || $(this).find('select[name="agency"]').length > 0 && $(this).find('select[name="agency"]').val().length > 0) {
                    $(this).addClass('active');
                }
            }
        })
    }
}


$(document).ready(function () {
    $wrapper.find('.wrapper__inner').css('padding-top', $header.outerHeight());

    if ($('.js-force-open').length) {
        if (window.matchMedia("(max-width: 800px)").matches) {
            var parent = $('.js-force-open').closest('.row');
            if (parent.length > 1) {
                parent.last().find('.accordion-expander').removeClass('js-force-open');
                parent = $('.js-force-open').closest('.row');
            }
            var firstAccordion = parent.find('.accordion-item-collum:first-child').children();
            if (firstAccordion.hasClass('accordion-expander')) {
                firstAccordion.find('.link-accordion-expander').toggleClass('active');
                firstAccordion.find('.collapsed-content').toggleClass('expand').stop(true).slideFadeToggle(500, updateSectionStepHeight);
            }
        }
    }
    //displayPartnerBanner();
    toggleLinkCursor();
    //onClosePartnerBanner();
    window.displayStickyBanner();
    window.onCloseStickyBanner();
    openPhonePopup();
    initContactScrollAccordeon();
});

/* Listen window events */
window.addEventListener("hashchange", locationHashChanged, false);

/* use when page was loaded from cache (when user click on back navigation button on mobile) */
window.onpageshow = function (event) {
    if (event.persisted) {
        handleFormCompletudeDatas();
        initAnimationFormMobile();
    }
};
